/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if ('__EXCLUDE_SLDS_ICONS__' === '__INCLUDE_SLDS_ICONS__') {
  icons = {
    custom1: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M54.3 74.1a5.983 5.983 0 01-8.7 0c-7.2-7.699-21-22.399-21-22.5-6.2-6.5-6.2-17.2 0-23.7 3-3.2 7-4.9 11.3-4.9 4.3 0 8.3 1.7 11.3 4.9l1.2 1.5c.8 1 2.4 1 3.2 0l1-1.3.2-.2c3.101-3.3 7.101-5 11.3-5 4.301 0 8.301 1.7 11.301 4.9 6.199 6.5 6.199 17.2 0 23.7C75.3 51.7 61.6 66.4 54.3 74.1z"
      }
    },
    custom10: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M69.8 77.9c-9.399 3.8-24.2 2.8-32.3-6C18 50.8 35.1 20 58.6 20c3.9 0 7.7.8 11.2 2.2 1.5.6 1.601 2.6.4 3.5C62.6 31.1 57.6 40 57.6 50c0 10.1 4.9 19 12.5 24.4 1.3.9 1.1 2.9-.3 3.5z"
      }
    },
    custom100: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M61.9 72H38.1c-.7 0-1.1.6-1 1.3 1 3.8 6.4 6.7 12.8 6.7 6.5 0 11.9-2.9 12.8-6.7.3-.7-.2-1.3-.8-1.3zM74 26H26c-3.3 0-6 2.7-6 6v28c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V32c0-3.3-2.7-6-6-6zm0 32c0 1.1-.9 2-2 2H28c-1.1 0-2-.9-2-2V34c0-1.1.9-2 2-2h44c1.1 0 2 .9 2 2v24z"
        }
      }
    },
    custom101: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M44.885 38.655a7.47 7.47 0 11-.066 14.938 7.47 7.47 0 01.066-14.938zm.505 31.491c.538-.239 1.168-.598 1.939-1.016a36.418 36.418 0 015.889-2.835 39.1 39.1 0 01-1.64-3.765c0-.086-.06-.205-.093-.298a17.263 17.263 0 01-6.6 1.328c-9.46.01-17.2-7.53-17.437-16.986-.237-9.457 7.116-17.375 16.564-17.838 9.449-.463 17.54 6.698 18.23 16.133 3.916.418 6.12 2.357 7.303 4.515.155-1.08.235-2.169.239-3.26.026-13.608-10.881-24.716-24.488-24.936-13.607-.221-24.869 10.526-25.284 24.128-.416 13.602 10.17 25.017 23.764 25.627a26.026 26.026 0 011.614-.81v.013zm29.878 2.238c-2.33-1.05-5.77-3.705-10.876-4.602 1.328-1.4 2.298-3.585 3.32-6.181.598-1.494.478-2.782.478-4.601 0-1.328.24-3.5-.086-4.688C66.968 48.328 64.12 47.2 60.8 47.2c-3.32 0-6.181 1.108-7.303 5.139-.326 1.195-.087 3.32-.087 4.687 0 1.826-.093 3.108.478 4.601 1.016 2.603 1.992 4.78 3.32 6.188-5.125.93-8.538 3.586-10.862 4.602-4.78 2.118-4.807 4.455-4.807 4.455v3.944h38.45v-3.944c.06 0 .06-2.357-4.754-4.482l.033-.006z",
        "fill-rule": "evenodd"
      }
    },
    custom102: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M31.179 60.7h-8.75a1.157 1.157 0 00-1.179 1.143V79.57a1.157 1.157 0 001.179 1.158h8.75a1.157 1.157 0 001.178-1.158V61.836a1.136 1.136 0 00-1.178-1.143v.007zm16.142-5.464h-8.75a1.157 1.157 0 00-1.142 1.135v23.25a1.157 1.157 0 001.178 1.143h8.714a1.157 1.157 0 001.179-1.143v-23.25a1.157 1.157 0 00-1.179-1.142v.007zM63.43 35.157h-8.75A1.157 1.157 0 0053.5 36.3v43.321a1.157 1.157 0 001.179 1.143h8.75a1.157 1.157 0 001.178-1.143V36.3a1.114 1.114 0 00-1.178-1.143zM79.57 21.23h-8.75a1.157 1.157 0 00-1.178 1.142v57.25a1.157 1.157 0 001.178 1.143h8.75a1.157 1.157 0 001.179-1.143v-57.25a1.157 1.157 0 00-1.179-1.142z",
        "fill-rule": "evenodd"
      }
    },
    custom103: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M76.14 54.901c-1.625-.77-4.012-2.713-7.553-3.365.913-1.03 1.591-2.609 2.302-4.513a8.824 8.824 0 00.352-3.365c0-.972.176-2.57-.058-3.45-.796-2.948-2.772-3.75-5.074-3.75s-4.311.828-5.074 3.776c-.235.854-.059 2.445-.059 3.424a9.046 9.046 0 00.352 3.39c.711 1.918 1.39 3.51 2.302 4.514a16.435 16.435 0 00-4.865 1.891 39.241 39.241 0 015.048 2.609c.796.47 1.507.887 2.067 1.148 2.713 1.272 4.22 2.654 5.107 3.913h8.543V58.2s-.058-1.741-3.39-3.306v.006zm-42.014 2.29c.561-.268 1.272-.653 2.067-1.149a38.074 38.074 0 015.074-2.608 16.52 16.52 0 00-4.95-1.898c.913-1.03 1.592-2.609 2.303-4.513a8.824 8.824 0 00.352-3.365c0-.972.176-2.57-.059-3.45-.796-2.948-2.772-3.75-5.074-3.75s-4.304.828-5.074 3.75c-.267.854-.091 2.445-.091 3.424a9.046 9.046 0 00.352 3.39c.711 1.918 1.39 3.51 2.302 4.514-3.508.652-5.87 2.609-7.493 3.365-3.333 1.565-3.365 3.261-3.365 3.261v2.89h8.582a13.096 13.096 0 015.074-3.862zm30.887 1.956c-2.42-1.122-6.02-4.044-11.328-5.048 1.356-1.533 2.387-3.913 3.45-6.757.652-1.65.502-3.039.502-5.047 0-1.474.267-3.835-.091-5.133-1.18-4.396-4.129-5.609-7.611-5.609-3.483 0-6.444 1.246-7.605 5.674-.326 1.272-.058 3.626-.058 5.107 0 2.008-.092 3.424.502 5.048 1.063 2.863 2.067 5.25 3.424 6.782-5.283 1.03-8.824 3.913-11.244 5.048-4.989 2.328-4.989 4.898-4.989 4.898v4.337h40.037v-4.344s0-2.57-4.989-4.924v-.032z",
        "fill-rule": "evenodd"
      }
    },
    custom104: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M72.72 20.574H27.28a3.088 3.088 0 00-3.045 3.088v15.485h51.486V23.706a3.088 3.088 0 00-3-3.132zM45.457 42.279v37.147H72.72a3.088 3.088 0 003.044-3.088V42.28h-30.31zm-21.177 0v34.06a3.062 3.062 0 003.045 3.087h15.132V42.28H24.279z",
        "fill-rule": "evenodd"
      }
    },
    custom105: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M76.053 26.316H23.947a3.6 3.6 0 00-3.552 3.623v2.558a.892.892 0 00.316.71l26.273 21.53a4.263 4.263 0 005.93 0l26.273-21.553a.892.892 0 00.316-.71V29.97a3.576 3.576 0 00-3.45-3.655zM20.418 37.929a.868.868 0 01.498-.79.79.79 0 01.955.143l12.75 11.297a.79.79 0 01.284.64.94.94 0 01-.244.67L21.91 61.93a.79.79 0 01-.956.213.86.86 0 01-.529-.853V37.93h-.008zm0 29.21a.971.971 0 01.285-.67l16.05-14.977a.837.837 0 011.168 0l6.782 6.04a7.697 7.697 0 0010.547 0l6.782-6.04a.868.868 0 011.168 0l16.058 14.945a.908.908 0 01.284.67v2.914a3.608 3.608 0 01-3.553 3.663H23.947a3.608 3.608 0 01-3.552-3.655v-2.913l.023.023zm59.156-5.857a.908.908 0 01-.53.852.868.868 0 01-.955-.213L65.34 49.858a.94.94 0 01-.244-.671.79.79 0 01.316-.64l12.75-11.329a.79.79 0 01.923-.102.9.9 0 01.53.79v23.352l-.04.024z",
        "fill-rule": "evenodd"
      }
    },
    custom106: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M49.643 20.543c-11.905.079-21.496 9.787-21.429 21.693 0 17.585 21.429 37.221 21.429 37.221S71.07 59.05 71.07 42.236c.056-11.9-9.528-21.603-21.428-21.693zm0 31.021a9.286 9.286 0 119.193-9.328 9.286 9.286 0 01-9.193 9.321v.007z",
        "fill-rule": "evenodd"
      }
    },
    custom107: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M77.734 51.48h-5.968v26.188a1.221 1.221 0 01-1.295 1.27H58.545a1.189 1.189 0 01-1.04-1.295V57.447H42.987v20.221c.049.63-.405 1.19-1.033 1.27H30.029a1.221 1.221 0 01-1.295-1.295V51.48h-5.968c-.516 0-1.04-.263-1.04-.78-.263-.516-.263-1.04.262-1.294L49.47 21.922c.517-.516 1.295-.516 1.558 0L78.512 49.43c.517.263.517.779.263 1.295-.255.517-.517.78-1.041.78v-.025z",
        "fill-rule": "evenodd"
      }
    },
    custom108: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "path": [{
          "d": "M47.9 60.35l.42-2.82 3.96-2.73-.87-3.72h-.54l-4.2-.33-1.62-2.28.93-4.8-3.12-2.01-.39.39-3.15 2.79-2.7-.42-2.64-4.08-3.57.9v.57l-.3 4.29-2.22 1.68-4.68-.99-1.92 3.27.36.42 2.7 3.27-.39 2.82-3.96 2.7.87 3.69.54.06 4.14.33 1.65 2.25-.96 4.8 3.15 1.98.42-.36 3.15-2.82 2.7.42 2.61 4.08 3.6-.9v-.6l.27-4.2 2.22-1.68 4.62.99 1.92-3.27-.36-.42-2.64-3.24v-.03zm-5.49.66a7.2 7.2 0 01-10.08 2.55 7.8 7.8 0 01-2.49-10.44 7.2 7.2 0 0110.08-2.58 7.8 7.8 0 012.49 10.47z"
        }, {
          "d": "M75.65 46.28l.42-2.82 3.93-2.7-.87-3.69h-.54l-4.14-.33-1.65-2.34.93-4.8-3.15-1.98-.42.36-3.15 2.79-2.7-.42-2.58-4.08-3.6.9-.06.6L57.8 32l-2.22 1.68-4.62-.96-1.92 3.27.36.45 2.7 3.27-.42 2.82-3.93 2.67.87 3.72h.54l4.14.33 1.62 2.31-.96 4.8 3.15 2.04.42-.36 3.15-2.82 2.7.42 2.61 4.08 3.57-.9.03-.57.3-4.29 2.22-1.68 4.65.96 1.92-3.27-.36-.42-2.67-3.27zm-5.52.66a7.2 7.2 0 01-10.08 2.55 7.752 7.752 0 01-2.46-10.44 7.2 7.2 0 0110.08-2.58 7.8 7.8 0 012.46 10.47z"
        }]
      }
    },
    custom109: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M79.651 46.442l-1.395-2.093-4.06 1.751c-5.247-8.449-14.854-14.651-24.88-14.651-14.881-.007-28.967 13.716-28.967 28.249v.893l.063 1.186h7.116l-.09-1.186a8.33 8.33 0 010-.858c0-11.742 9.815-21.321 21.885-21.321a22.019 22.019 0 0118.768 10.381l-13.905 6.042a8.135 8.135 0 00-8.923-.977 7.674 7.674 0 00-3.349 10.528 8.1 8.1 0 0010.793 3.293 7.744 7.744 0 004.242-7.71l12.9-7.674a20.623 20.623 0 011.395 7.445v.858l-.09 1.186h7.116l.063-1.186a8.623 8.623 0 000-.893 25.165 25.165 0 00-2.652-10.891l3.97-2.372z",
        "fill-rule": "evenodd"
      }
    },
    custom11: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M52.2 21.4l8 16.9L77.9 41c2 .3 2.8 2.9 1.3 4.3L66.4 58.5l3 18.5c.3 2.1-1.7 3.7-3.5 2.7L50 70.9l-15.9 8.8c-1.8 1-3.9-.601-3.5-2.7l3-18.5-12.9-13.2c-1.4-1.5-.6-4 1.3-4.3l17.8-2.7 8-16.9c.9-1.9 3.5-1.9 4.4 0z"
      }
    },
    custom110: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M61.714 20.229H38.286a5.986 5.986 0 00-6.143 5.928v47.536a6.129 6.129 0 006.143 6.071h23.428a6.129 6.129 0 006.143-6.071V26.157a5.986 5.986 0 00-6.143-5.928zm-16.071 3.428h8.714a.55.55 0 01.536.536.607.607 0 01-.536.536h-8.714a.536.536 0 110-1.072zm7.75 51.857a.643.643 0 01-.714.536h-5.536a.55.55 0 01-.536-.536v-2.5c0-.25.286-.643.536-.643h5.571a.714.714 0 01.715.643v2.5h-.036zm10.928-7.357a.629.629 0 01-.678.643H36.357a.629.629 0 01-.714-.643v-39.5a.75.75 0 01.714-.786h27.25c.4.038.7.385.679.786v39.5h.035z",
        "fill-rule": "evenodd"
      }
    },
    custom111: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "path": {
          "d": "M53.373 45.053c-.06 0-.093 0-.12-.06-2.306-.993-5.7-3.66-10.74-4.566 1.287-1.334 2.28-3.507 3.267-6.087.573-1.473.48-2.733.48-4.533 0-1.334.24-3.447-.093-4.62-1.107-4-3.9-5.074-7.2-5.074-3.3 0-6.12 1.114-7.234 5.074-.326 1.166-.06 3.3-.06 4.62 0 1.8-.093 3.06.48 4.56 1.02 2.553 2 4.713 3.24 6.086-4.98.934-8.373 3.54-10.666 4.534C20.047 47.12 20 49.4 20 49.4v7.593h23.653a20.1 20.1 0 019.72-11.94zM62.827 70.46a7.767 7.767 0 117.766-7.793 7.773 7.773 0 01-7.766 7.793zM80 64.547v-3.88l-.54-.18-4.2-1.334-1.107-2.666 2.127-4.527-2.76-2.76-.513.267-3.9 2-2.667-1.114-1.68-4.706h-3.947l-.146.486-1.38 4.167-2.667 1.113L52 49.28l-2.733 2.76.266.513 2 3.927-1.113 2.667-4.707 1.68v3.9l.54.18 4.174 1.38 1.113 2.666-2.207 4.6 2.76 2.76.507-.266 3.933-2L59.2 75.16l1.68 4.707h3.9l.18-.54 1.38-4.167 2.667-1.113 4.533 2.126 2.76-2.76-.267-.506-2-3.9 1.107-2.667L80 64.547z"
        }
      }
    },
    custom112: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M51.121 50.166a56.676 56.676 0 00-25.737 0 7.271 7.271 0 00-4.973 6.513v5.25a7.192 7.192 0 004.973 6.513c.79.197 1.58.316 2.369.474l6.67 9.552c1.224 1.737 2.211 1.421 2.211-.71v-7.895c4.87.16 9.74-.318 14.487-1.42a7.271 7.271 0 004.974-6.514v-5.25a7.16 7.16 0 00-4.974-6.513zm23.526-27.632a72.15 72.15 0 00-35.052 0 7.279 7.279 0 00-4.974 6.553v9.316a7.279 7.279 0 004.974 6.552 71.424 71.424 0 0019.579 2.092v10.974c0 2.092.987 2.447 2.17.71l8.961-12.789a75.61 75.61 0 004.303-.947 7.279 7.279 0 004.974-6.553v-9.316a7.184 7.184 0 00-4.935-6.552v-.04z",
        "fill-rule": "evenodd"
      }
    },
    custom113: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "path": {
          "d": "M27.16 59.042h45.735a.64.64 0 00.592-.631V26.816c0-.671-.513-.987-1.184-.987h-44.55c-.632 0-1.303.316-1.303.987v31.579c0 .316.395.631.71.631v.016zm3.893-27.947a.608.608 0 01.592-.592H68.3a.608.608 0 01.592.592v22.697a.608.608 0 01-.592.592H31.621a.608.608 0 01-.592-.592V31.095h.024zM79.463 73.34l-5.842-11.843a.663.663 0 00-.513-.355H26.884a.663.663 0 00-.513.355L20.53 73.34a1.255 1.255 0 001.05 1.856H78.42a1.263 1.263 0 001.026-1.856h.016zm-23.479-.735h-11.92a.387.387 0 01-.277-.552l1.697-3.237a.663.663 0 01.513-.355h8.014c.204.009.393.11.513.276l1.697 3.316c.118.197 0 .552-.237.552z"
        }
      }
    },
    custom12: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "50",
        "cy": "50",
        "r": "30"
      }
    },
    custom13: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M74 22H26c-3.3 0-6 2.7-6 6v6c0 1.1.9 2 2 2h56c1.1 0 2-.9 2-2v-6c0-3.3-2.7-6-6-6zM74 42H26c-1.1 0-2 .9-2 2v28c0 3.3 2.7 6 6 6h40c3.3 0 6-2.7 6-6V44c0-1.1-.9-2-2-2zm-13 9c0 1.6-1.3 3-3 3H42c-1.6 0-3-1.3-3-3 0-1.6 1.3-3 3-3h16c1.7 0 3 1.3 3 3z"
        }
      }
    },
    custom14: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M78 33h-6c-1.3 0-2.6-.6-3.6-1.5l-4.8-4.1c-1-.8-2.3-1.4-3.6-1.4H48.3c-1.5 0-2.9.6-4 1.7l-6.2 5.1c-.5.4-.5 1.2-.1 1.7l1.9 1.8c1.3 1 3 1.2 4.3.3l5.5-3.3c.7-.5 1.7-.3 2.3.3l17.3 16.8c.4.4.7 1 .7 1.6v4.5c0 1.2.9 2.5 2 2.5h6c1.1 0 2-.9 2-2.1V35c0-1.2-.9-2-2-2z"
        }, {
          "d": "M61 51L50.2 40.5l-3 1.8c-1.5.9-3.2 1.4-4.9 1.4-2.1 0-4.3-.8-6-2.2l-3.9-3.2c-.9-.7-1.4-1.5-1.5-2.6-.2-1.1-1-1.7-2-1.7H22c-1.1 0-2 .6-2 1.8V54c0 1.2.9 2 2 2h4c.3 0 .7-1.1 1.1-1.6 1.5-2 3.7-3.101 6.1-3.4 2.4-.2 4.7.6 6.6 2.3l12.5 11.4c1.101 1 1.9 2.1 2.4 3.5.3.7 1.1.899 1.6.399L61 63.9c2.4-2.4 4.2-8 2-10.601L61 51z"
        }, {
          "d": "M35.9 58.4c-1.3-1.2-3.2-1-4.2.399-1.1 1.4-.9 3.4.4 4.601l12.5 11.3c.6.6 1.4.8 2.2.7.8-.101 1.5-.5 2-1.2 1.1-1.4.9-3.4-.4-4.601L35.9 58.4z"
        }]
      }
    },
    custom15: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M70 46.1c-3.5-1.5-4-2.8-4-4.2 0-1.5 1-2.8 2.2-3.9 2.1-1.9 3.2-4.5 3.2-7.5 0-5.6-3.5-10.5-9.801-10.5C56.2 20 52.9 23.6 52 28.2c-.1.4.1.8.4 1 4.5 3.2 7.3 8.6 7.3 15.1 0 4.5-1.5 8.601-4.3 11.7-.4.5-.3 1.3.4 1.6 1.7.7 3.7 1.7 5.7 2.801.6.399 1.3.6 2 .6H75c2.8 0 5-2.2 5-4.9v-.8C80 50.8 75.1 48.3 70 46.1z"
        }, {
          "d": "M52.1 62.6c-4.2-1.699-4.8-3.3-4.8-5 0-1.699 1.2-3.3 2.6-4.6 2.4-2.2 3.8-5.2 3.8-8.8 0-6.6-4.2-12.3-11.6-12.3s-11.6 5.7-11.6 12.3c0 3.6 1.3 6.6 3.8 8.8 1.4 1.2 2.6 2.9 2.6 4.6 0 1.7-.6 3.2-4.8 5-6.1 2.5-11.9 5.4-12 10.7v.9c0 3.2 2.7 5.8 6 5.8H58c3.3 0 6-2.6 6-5.8v-.9c0-5.3-5.8-8.2-11.9-10.7z"
        }]
      }
    },
    custom16: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M72 70h-1V48c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v22h-6V48c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v22h-6V48c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v22h-6V48c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v22h-1c-3.3 0-6 2.7-6 6v2c0 1.1.9 2 2 2h52c1.1 0 2-.9 2-2v-2c0-3.3-2.7-6-6-6zM77 34.4L52.3 20.8c-.7-.5-1.5-.8-2.3-.8-.8 0-1.6.3-2.3.8L23 34.4c-.6.4-1 1-1 1.7V38c0 1.1.9 2 2 2h52c1.1 0 2-.9 2-2v-1.8c0-.7-.4-1.4-1-1.8zM50 36c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
        }
      }
    },
    custom17: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M43 28.9c.3.7 1 1.1 1.8 1.1H55c.8 0 1.5-.4 1.8-1.1l4-7.4c.3-.7-.2-1.4-.899-1.4H40.1c-.7 0-1.2.8-.9 1.4l3.8 7.4zM55.9 36H44c-9.9 0-18 8.1-18 18v20c0 3.3 2.7 6 6 6h35.9c3.3 0 6.1-2.7 6.1-6V54c0-9.9-8.2-18-18.1-18zM53 69.6V73c0 .6-.6 1-1.2 1h-4c-.6 0-.8-.4-.8-1v-3.3c-3-.601-5.5-1.9-6.2-2.5-.8-.7-1-1.4-.4-2.3l1.3-2c.3-.5.9-.801 1.5-.801.4 0 .7.101 1 .301h.1c2 1.199 3.8 1.8 5.1 1.8 1.4 0 2.5-.7 2.5-1.5 0-.601-.4-1.601-4.2-2.9-3.4-1.2-7.6-3.3-7.6-7.899 0-2.7 1.8-5.9 6.8-6.9v-3c0-.6.3-1 .8-1h4c.6 0 1.2.4 1.2 1v3c2 .5 4.199 1.5 4.899 2 .4.2.601.7.7 1.2s-.1 1-.4 1.3l-1.5 1.8c-.399.5-1.1.9-1.699.9-.3-.001-.6-.101-.9-.201-2-1.1-3.7-1.7-4.8-1.7-1.7 0-2.4.8-2.4 1.3 0 .7.4 1.5 3.8 2.7 4.2 1.4 8.9 3.601 8.9 8.3.1 3.2-2.5 6.1-6.5 7z"
        }
      }
    },
    custom18: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M60 36h10.6c.801 0 1.4-.6 1.4-1.4 0-.4-.1-.7-.4-1L58.4 20.4c-.3-.3-.6-.4-1-.4-.8 0-1.4.6-1.4 1.4V32c0 2.2 1.8 4 4 4zM83.4 49.6l-1.2-1.2c-.8-.8-2-.8-2.8 0L64 63.9c-.1.1 0 .2 0 .4v3.3c0 .301 0 .5.3.5h3.3c.1 0 .3-.1.4-.1l15.4-15.4c.8-1 .8-2.2 0-3z"
        }, {
          "d": "M70.9 74h-9.1c-2.1 0-3.8-1.7-3.8-3.8v-7c0-1.101.3-2.101 1.1-2.8L71.4 48c.399-.4.6-.9.6-1.4V44c0-1.1-.9-2-2-2H56c-3.3 0-6-2.7-6-6V22c0-1.1-.9-2-2-2H28c-3.3 0-6 2.7-6 6v48c0 3.3 2.7 6 6 6h38c2.9 0 5.4-2.1 5.9-4.8.1-.6-.4-1.2-1-1.2zM30 38c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-2zm20 26c0 1.1-.9 2-2 2H32c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v2zm4-12c0 1.1-.9 2-2 2H32c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v2z"
        }]
      }
    },
    custom19: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M79.2 32.8c-.2-.7-1.101-.9-1.7-.4L67.4 42.5c-.801.8-2 .8-2.801 0l-7.1-7.1c-.8-.8-.8-2 0-2.8l10.2-10.2c.5-.5.3-1.4-.4-1.7C65.6 20.3 63.8 20 62 20c-10.6 0-19.1 9.2-17.9 20 .2 1.7.6 3.2 1.2 4.7L22 68.1c-2.7 2.7-2.7 7.2 0 9.9 1.4 1.4 3.2 2.1 5 2.1s3.6-.699 5-2.1l23.3-23.3c1.5.6 3.101 1 4.7 1.2 10.9 1.2 20-7.3 20-17.9 0-1.8-.3-3.6-.8-5.2z"
      }
    },
    custom2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M59 22c-3-2-13.8-3.9-18 3-2 3.3.4 9.1 2.2 12.8.5.9 1.5 1.4 2.5 1 1.3-.5 2.8-.8 4.3-.8 1 0 2 .1 3 .4.9.2 1.8-.2 2.2-1 .7-1.3 1.899-2.8 3.8-4.4 5-4 3-9 0-11zM53.8 61.4c-1.2.4-2.5.6-3.8.6-1.2 0-2.4-.2-3.5-.5-.9-.3-1.9.2-2.3 1-.7 1.3-1.9 2.9-3.9 4.5-5 4-3 9.1 0 11.1s13.9 3.9 18-3c1.9-3.199-.3-9-2.1-12.699-.5-.901-1.5-1.301-2.4-1.001zM75 41c-3.3-2-9.1.4-12.8 2.2-.9.5-1.4 1.5-1 2.5.5 1.3.8 2.8.8 4.3 0 1-.1 2-.4 3-.199.9.2 1.8 1 2.2 1.3.7 2.8 1.9 4.4 3.8 4 5 9 3 11 0s3.9-13.9-3-18zM38.6 53.8c-.4-1.2-.6-2.5-.6-3.8 0-1.2.2-2.4.5-3.5.3-.9-.2-1.9-1-2.3-1.3-.7-2.9-1.9-4.5-3.9-4-5-9.1-3-11.1 0s-3.9 13.8 3 18c3.2 1.9 9-.3 12.7-2.1.9-.5 1.3-1.5 1-2.4z"
        },
        "circle": {
          "cx": "50",
          "cy": "50",
          "r": "6"
        }
      }
    },
    custom20: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M38 47.7c0-.8-1-1.3-1.6-.8l-14 10.8c-1.5 1.1-2.4 2.9-2.4 4.8v4.1c0 .7.7 1.2 1.3.9l15.4-5.8c.8-.3 1.3-1 1.3-1.9V47.7zM60.1 75.7L56 73V27.6c0-2.7-2.9-5.7-4.8-7.2-.7-.6-1.8-.6-2.5 0-1.8 1.5-4.8 4.5-4.8 7.2V73l-4.6 3c-.8.6-1.4 1.5-1.4 2.5v.6c0 .5.4.9.9.9h22.1c.5 0 1.1-.4 1.1-.9 0-1.4-.8-2.6-1.9-3.4zM77.6 57.7l-14-10.8a1 1 0 00-1.6.8v12.2c0 .8.5 1.6 1.3 1.899l15.4 5.8c.7.201 1.3-.199 1.3-.899v-4.1c0-2-.9-3.8-2.4-4.9z"
        }
      }
    },
    custom21: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M57.6 71.1c-.3-.699-1-1.1-1.8-1.1H44.2c-.8 0-1.5.4-1.8 1.1l-2.7 7.4c-.3.7.2 1.4.9 1.4h18.8c.699 0 1.199-.801.899-1.4L57.6 71.1zM74 20H26c-3.3 0-6 2.7-6 6v32c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V26c0-3.3-2.7-6-6-6zM50 62c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm24-10c0 1.1-.9 2-2 2H28c-1.1 0-2-.9-2-2V28c0-1.1.9-2 2-2h44c1.1 0 2 .9 2 2v24z"
        }
      }
    },
    custom22: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M77.7 63.9l-6.2-5a6.002 6.002 0 00-7.3-.2L58.3 63c-.8.6-1.899.5-2.6-.2L46 54l-8.9-9.8c-.7-.7-.8-1.8-.2-2.6l4.3-5.9c1.6-2.2 1.5-5.2-.2-7.3l-5-6.2c-2.2-2.8-6.4-3-8.9-.5l-5.4 5.4c-1.2 1.2-1.8 2.9-1.8 4.5.7 12.7 6.5 24.8 15 33.3s20.5 14.3 33.3 15c1.7.1 3.3-.601 4.5-1.801l5.4-5.399c2.7-2.4 2.4-6.6-.4-8.8z"
      }
    },
    custom23: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M48.7 56c.8.7 1.899.7 2.7 0l28.3-26.2c.5-1 .399-2.6-1.601-2.6l-56 .1c-1.5 0-2.7 1.4-1.6 2.6L48.7 56z"
        }, {
          "d": "M80 41c0-1.3-1.6-2-2.5-1.1l-22 20.4c-1.5 1.4-3.4 2.1-5.4 2.1-2 0-3.9-.7-5.4-2.101L22.6 39.9c-1-.9-2.5-.2-2.5 1.1v26c0 3.3 2.7 6 6 6h48c3.301 0 6-2.7 6-6-.1 0-.1-18-.1-26z"
        }]
      }
    },
    custom24: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M68.1 20H31.9c-3.3 0-5.9 2.7-5.9 5.9v.1c0 1.1.9 2 2 2h44c1.1 0 2-.9 2-2v-.1c0-3.2-2.7-5.9-5.9-5.9zM68 34H32c-1.1 0-2 .9-2 2v42c0 1.1.9 2 2 2h11.1c1.1 0 1.9-.9 1.9-2v-8c0-1.1 1-2 2.1-2h5.8c1.1 0 2.1.9 2.1 2v8c0 1.1.8 2 1.9 2H68c1.1 0 2-.9 2-2V36c0-1.1-.9-2-2-2zM47 61c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v4zm0-14c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v4zm14 14c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v4zm0-14c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v4z"
        }
      }
    },
    custom25: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M79.8 27.3c-.7-3.7-3.8-6.7-7.6-7.2-2.7-.4-5.2.5-7.101 2-.6.5-.5 1.3.2 1.7 4.601 2.4 8.5 5.9 11.5 10.1.4.6 1.3.6 1.7 0C79.8 32 80.3 29.7 79.8 27.3zM34.6 23.8c.6-.3.7-1.2.2-1.7-1.9-1.6-4.4-2.4-7.1-2-3.8.5-6.9 3.5-7.6 7.2-.4 2.4.1 4.7 1.3 6.5.4.6 1.3.6 1.7 0 3-4.1 6.9-7.6 11.5-10zM50 26c-14.9 0-27 12.1-27 27 0 6 2 11.6 5.3 16l-4.1 4.1c-1.6 1.601-1.6 4.101 0 5.7.8.8 1.8 1.2 2.8 1.2s2-.4 2.8-1.2l4.1-4.1C38.4 78 44 80 50 80s11.6-2 16-5.3l4.1 4.1C71 79.6 72 80 73 80s2-.4 2.8-1.2c1.601-1.6 1.601-4.1 0-5.7L71.7 69C75 64.6 77 59 77 53c0-14.9-12.1-27-27-27zM31 53c0-10.5 8.5-19 19-19s19 8.5 19 19-8.5 19-19 19-19-8.5-19-19z"
        }, {
          "d": "M53 51.8V44c0-1.7-1.3-3-3-3s-3 1.3-3 3v9c0 .8.3 1.6.9 2.1l7 7c.6.6 1.4.9 2.1.9s1.5-.3 2.1-.9c1.2-1.199 1.2-3.1 0-4.199L53 51.8z"
        }]
      }
    },
    custom26: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M26 20c-3.3 0-6 2.7-6 6 0 1.8.8 3.4 2 4.5V76c0 2.2 1.8 4 4 4s4-1.8 4-4V30.5c1.2-1.1 2-2.7 2-4.5 0-3.3-2.7-6-6-6zM78.5 30.8c-15.7 8.2-26.4-5.9-41.2-.5-.8.3-1.3 1-1.3 1.9V58c0 1.3 1.3 2.3 2.6 1.9 14.2-4.3 24.9 9.1 40.4.6.6-.3 1-1 1-1.7V31.7c0-.8-.8-1.3-1.5-.9z"
        }
      }
    },
    custom27: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M24 63h52c1.1 0 2-.9 2-2V29c0-3.3-2.7-6-6-6H28c-3.3 0-6 2.7-6 6v32c0 1.1.9 2 2 2zm4-32c0-1.1.9-2 2-2h40c1.1 0 2 .9 2 2v24c0 1.1-.9 2-2 2H30c-1.1 0-2-.9-2-2V31zM80 69H58c-1.1 0-2 .9-2 2s-.9 2-2 2h-8c-1.1 0-2-.9-2-2s-.9-2-2-2H20c-1.1 0-2 .9-2 2 0 3.3 2.7 6 6 6h52c3.3 0 6-2.7 6-6 0-1.1-.9-2-2-2z"
        }
      }
    },
    custom28: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M64 20H36c-3.3 0-6 2.7-6 6v48c0 3.3 2.7 6 6 6h28c3.3 0 6-2.7 6-6V26c0-3.3-2.7-6-6-6zM50 78c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm14-10c0 1.1-.9 2-2 2H38c-1.1 0-2-.9-2-2V30c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2v38z"
      }
    },
    custom29: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M73.9 28h-1.8c-1.2 0-2.1 1-2.1 2.2V70c0 .1 0 .3.1.4l2.5 3.5c.2.199.5.199.801 0l2.5-3.5c.099-.1.099-.2.099-.4V30.2c0-1.2-.9-2.2-2.1-2.2zM58 20H30c-3.3 0-6 2.7-6 6v48c0 3.3 2.7 6 6 6h28c3.3 0 6-2.7 6-6V26c0-3.3-2.7-6-6-6zM44 78c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm14-10c0 1.1-.9 2-2 2H32c-1.1 0-2-.9-2-2V30c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2v38z"
        }
      }
    },
    custom3: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M50 38c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12z"
        }, {
          "d": "M80 50c0-3.5-8.4-5.3-9.7-8.4-1.3-3.2 3.3-10.4.9-12.8-2.4-2.4-9.601 2.2-12.8.9-3.1-1.3-4.9-9.7-8.4-9.7s-5.3 8.4-8.4 9.7c-3.2 1.3-10.4-3.3-12.8-.9-2.4 2.4 2.2 9.6.9 12.8-1.3 3.1-9.7 4.9-9.7 8.4s8.4 5.3 9.7 8.4c1.3 3.2-3.3 10.4-.9 12.8 2.4 2.399 9.6-2.2 12.8-.9 3.1 1.3 4.9 9.7 8.4 9.7s5.3-8.4 8.4-9.7c3.2-1.3 10.4 3.3 12.8.9 2.4-2.4-2.2-9.6-.9-12.8 1.3-3.1 9.7-4.9 9.7-8.4zM50 68c-9.9 0-18-8.1-18-18s8.1-18 18-18 18 8.1 18 18-8.1 18-18 18z"
        }]
      }
    },
    custom30: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M71.5 28.5C66 23 58.7 20 51 20c-1.7 0-3 1.3-3 3s1.3 3 3 3c6.1 0 11.9 2.4 16.3 6.7C71.6 37.1 74 42.9 74 49c0 1.7 1.3 3 3 3s3-1.3 3-3c0-7.7-3-15-8.5-20.5z"
        }, {
          "d": "M51 32c-1.7 0-3 1.3-3 3s1.3 3 3 3c2.9 0 5.7 1.1 7.8 3.2C60.9 43.3 62 46 62 49c0 1.7 1.3 3 3 3s3-1.3 3-3c0-4.5-1.8-8.8-5-12s-7.5-5-12-5zM46.7 60.7l2.6-7c1.8.7 3.8.3 5.3-1.101 2-2 2-5.1 0-7.1s-5.1-2-7.1 0c-1.5 1.5-1.8 3.7-1 5.6L40 54 28.3 42.3c-.8-.8-2.2-.8-2.9.1-7.5 9-7 22.4 1.5 30.8 8.4 8.399 21.8 8.899 30.8 1.5.9-.7.9-2.1.1-2.9L46.7 60.7z"
        }]
      }
    },
    custom31: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M75.5 43.2l-4.9-15.4C69.7 24.9 67 23 64 23H36c-3 0-5.7 1.9-6.7 4.8l-4.8 15.4c-2.6.7-4.5 3-4.5 5.8v12c0 2.6 1.7 4.8 4 5.7V75c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8h28v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8.3c2.3-.8 4-3 4-5.7V49c0-2.8-1.9-5.1-4.5-5.8zM30 60c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm22-17H32.2c-.7 0-1.2-.7-1-1.3l3.8-12c.1-.4.5-.7.9-.7h28c.399 0 .8.3.899.6l3.8 12.1c.2.6-.3 1.3-1 1.3H52zm17 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
      }
    },
    custom32: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M78.5 35.3L55.1 48.6c-.5.3-1 .4-1.5.4-1.1 0-2.199-.6-2.699-1.7-.7-1.4 0-3.2 1.399-4l7.8-4.4v-7.7c0-.8-.8-1.2-1.5-.9L30.1 46.6c-.5.3-1 .4-1.5.4-1 0-2.1-.5-2.6-1.5-.8-1.4-.3-3.3 1.1-4.1l4.9-2.8V22c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v52c0 3.3 2.7 6 6 6h17c1.1 0 2-.9 2-2v-7c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v7c0 1.1.9 2 2 2h17c3.3 0 6-2.7 6-6V36.2c0-.8-.8-1.3-1.5-.9zM35 63c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6zm12 0c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6zm12 0c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6zm12 0c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6z"
      }
    },
    custom33: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M65 42H36c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h29c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm-14 9c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        }, {
          "d": "M80 28H20c-1.1 0-2 .9-2 2v2c0 2.2 1.8 4 4 4v36c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V36h45v36c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V36h-1c2.2 0 4-1.8 4-4v-2c0-1.1-.9-2-2-2z"
        }]
      }
    },
    custom34: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M42 30h16c1.1 0 2-1.1 1.8-2.2-1-4.5-5-7.8-9.8-7.8s-8.8 3.4-9.8 7.8c-.2 1.1.7 2.2 1.8 2.2z"
        }, {
          "d": "M77 56c1.7 0 3.1-1.4 3-3.2-.1-1.6-1.5-2.8-3.2-2.8H68v-5c5.8-2.3 9.9-8.5 10-15.9 0-1.5-1-2.8-2.5-3.1-1.9-.3-3.5 1.1-3.5 3 0 4.3-2 8-4.9 9.8-1.1-1.7-3-2.8-5.1-2.8H38c-2.1 0-4 1.1-5.1 2.8C30 37 28 33.4 28 29.2c0-1.6-1.2-3.1-2.8-3.2-1.8-.1-3.2 1.3-3.2 3 0 7.4 4.2 13.7 10 16v5h-8.8c-1.6 0-3.1 1.2-3.2 2.8-.1 1.7 1.3 3.2 3 3.2h9v5c-5.8 2.3-9.9 8.5-10 15.9 0 1.5 1 2.8 2.5 3.1 1.9.3 3.5-1.1 3.5-3 0-4.2 1.9-7.9 4.8-9.7 1.7 5.601 6.1 10 11.6 11.8 1.3.4 2.6-.6 2.6-1.899v-24c0-1.601 1.2-3.1 2.8-3.2 1.7-.1 3.2 1.3 3.2 3v24.2c0 1.399 1.3 2.3 2.6 1.899 5.5-1.8 9.9-6.199 11.601-11.8 2.8 1.8 4.7 5.4 4.8 9.5 0 1.601 1.2 3.101 2.8 3.2 1.8.1 3.2-1.3 3.2-3 0-7.4-4.2-13.7-10-16v-5H77z"
        }]
      }
    },
    custom35: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M69 40c-1.7 0-3 1.3-3 3v5c0 8.8-7.2 16-16 16s-16-7.2-16-16v-5c0-1.7-1.3-3-3-3s-3 1.3-3 3v5c0 11.1 8.3 20.3 19 21.8V74h-5c-1.7 0-3 1.3-3 3s1.3 3 3 3h16c1.7 0 3-1.3 3-3s-1.3-3-3-3h-5v-4.2C63.7 68.3 72 59.1 72 48v-5c0-1.7-1.3-3-3-3z"
        }, {
          "d": "M50 58c5.5 0 10-4.5 10-10V29.9c0-5.5-4.4-9.9-9.9-9.9h-.2c-5.5 0-9.9 4.4-9.9 9.9V48c0 5.5 4.5 10 10 10z"
        }]
      }
    },
    custom36: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M38.7 72h-4.1c-.7 0-1.4.4-1.7 1l-1.4 2.4c-.8 1.4-.5 3.2.8 4.1.5.4 1.1.5 1.7.5 1 0 2-.5 2.6-1.5l3-5c.4-.7-.1-1.5-.9-1.5zM67.1 73c-.399-.6-1-1-1.699-1H61.3c-.8 0-1.3.8-.899 1.5l3 5C64 79.5 65 80 66 80c.6 0 1.2-.2 1.7-.5 1.3-.9 1.6-2.8.8-4.1L67.1 73zM67 20H33c-3.3 0-6 2.7-6 6v34c0 3.3 2.7 6 6 6h34c3.3 0 6-2.7 6-6V26c0-3.3-2.7-6-6-6zM36 62c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm28 0c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm3-12c0 1.1-.9 2-2 2H35c-1.1 0-2-.9-2-2V30c0-1.1.9-2 2-2h30c1.1 0 2 .9 2 2v20z"
        }
      }
    },
    custom37: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M80 56H67V44.2c2.7 2.3 6.2 3.8 10 3.8 1.7 0 3-1.3 3-3s-1.3-3-3-3c-5.5 0-10-4.9-10-11v-3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2v3c0 6.1-4.9 11-11 11s-11-4.9-11-11v-3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2v3c0 6.1-4.5 11-10 11-1.7 0-3 1.3-3 3s1.3 3 3 3c3.8 0 7.3-1.4 10-3.8V56H20c-1.1 0-2 .9-2 2v4.8c0 1.101.9 2.2 2 2.2h4v10.8c0 1.101.9 2.2 2 2.2h6c1.1 0 2-1.1 2-2.2v-4c0-3.3 2.7-5.8 6-5.8h20c3.3 0 6 2.5 6 5.8v4c0 1.101.9 2.2 2 2.2h6c1.1 0 2-1.1 2-2.2V65h4c1.1 0 2-1.1 2-2.2V58c0-1.1-.9-2-2-2zM39 43.9c3 2.5 6.8 4.1 11 4.1s8-1.5 11-4.1V56H39V43.9z"
      }
    },
    custom38: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M50 45c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
        }, {
          "d": "M74 35h-8.1c-.801 0-1.5-.4-1.801-1.2l-2.6-5.5c-1-2-3.1-3.3-5.4-3.3H43.9c-2.3 0-4.4 1.3-5.4 3.3l-2.6 5.5c-.3.7-1 1.2-1.8 1.2H26c-3.3 0-6 2.7-6 6v28c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V41c0-3.3-2.7-6-6-6zM50 67.2c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14z"
        }]
      }
    },
    custom39: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M63.6 28.6c-.199-.8-1.1-1.3-1.899-1.1l-40.3 13c-1 .3-1.5 1.4-1.3 2.4l1.6 6.2c.3 1 1.3 1.7 2.3 1.5L34.2 49.2c.3 1.1.8 2.2 1.5 3.1L27 75.9c-.6 1.6.2 3.3 1.8 3.899.3.101.7.2 1 .2 1.2 0 2.4-.8 2.8-2l8.2-22.4c.7.2 1.3.2 2 .2s1.4-.1 2-.2L53.1 78c.4 1.2 1.601 2 2.801 2 .3 0 .699-.1 1-.2 1.6-.6 2.399-2.3 1.8-3.899L50 52.2c1.1-1.5 1.8-3.4 1.8-5.4v-.1l14.101-2c.899-.1 1.5-1 1.199-1.9l-3.5-14.2zM79.9 42.7l-5.5-20.4c-.4-1.6-2.101-2.6-3.7-2.2-1.601.4-2.601 2.1-2.2 3.7L74 44.2c.4 1.6 2.1 2.6 3.7 2.2 1.6-.4 2.6-2.1 2.2-3.7z"
        }
      }
    },
    custom4: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M26.2 32.7L47 20.8c1.9-1.1 4.3-1.1 6.2 0l20.7 11.9c1.899 1.1 3.1 3.2 3.1 5.4v23.8c0 2.199-1.1 4.3-3.1 5.399L53.2 79.2c-1.9 1.1-4.3 1.1-6.2 0L26.2 67.3c-1.9-1.1-3.2-3.2-3.2-5.4V38.1c0-2.2 1.3-4.3 3.2-5.4z"
      }
    },
    custom40: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M74 28H26c-3.3 0-6 2.7-6 6v34c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V34c0-3.3-2.7-6-6-6zm0 6v6H26v-6h48zM26 68V50h48v18H26z"
        }, {
          "d": "M43.1 55c-1.4 0-2.6.7-3.3 1.8-.1.2-.4.2-.5 0-.7-1.1-1.9-1.8-3.3-1.8-2.2 0-4 1.8-4 4s1.8 4 4 4c1.4 0 2.6-.7 3.3-1.8.1-.2.4-.2.5 0 .7 1.1 1.9 1.8 3.3 1.8h.1c2.1 0 3.9-1.7 3.9-3.9v-.2c-.1-2.2-1.8-3.9-4-3.9zM66 56H54c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2z"
        }]
      }
    },
    custom41: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M76 29H24c-3.3 0-6 2.7-6 6v29c0 3.3 2.7 6 6 6h52c3.3 0 6-2.7 6-6V35c0-3.3-2.7-6-6-6zM31 64c0-3.9-3.1-7-7-7V42c3.9 0 7-3.1 7-7h38c0 3.9 3.1 7 7 7v15c-3.9 0-7 3.1-7 7H31z"
        },
        "circle": {
          "cx": "50",
          "cy": "49",
          "r": "10"
        }
      }
    },
    custom42: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M74 22H26c-3.3 0-6 2.7-6 6v6c0 1.1.9 2 2 2h56c1.1 0 2-.9 2-2v-6c0-3.3-2.7-6-6-6zM74 42H26c-1.1 0-2 .9-2 2v28c0 3.3 2.7 6 6 6h40c3.3 0 6-2.7 6-6V44c0-1.1-.9-2-2-2zm-13 9c0 1.6-1.3 3-3 3H42c-1.6 0-3-1.3-3-3 0-1.6 1.3-3 3-3h16c1.7 0 3 1.3 3 3z"
        }
      }
    },
    custom43: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M81.7 43.2s.1 0 0 0c.1-.3.2-.4.2-.6v-.2-.6-.4-.2c0-.1-.101-.2-.101-.3s0-.1-.1-.2c0-.1-.101-.2-.2-.3 0-.1-.1-.1-.1-.2l-12-17C68.9 22.5 68 22 67 22H31c-1 0-1.9.5-2.5 1.3l-12 17c0 .1-.1.1-.1.2-.1.1-.1.2-.2.3 0 .1 0 .1-.1.2 0 .1-.1.2-.1.3V42.7c0 .2.1.4.2.5v.1c.1.1.1.3.2.4 0 .1.1.1.1.2l.2.2 30 33 .1.101.1.1.1.099s.1 0 .1.1c.1 0 .1.1.2.1 0 0 .1 0 .1.101 0 0 .1 0 .1.1 0 0 .1 0 .1.101H49.7s.1 0 .1-.101c0 0 .1 0 .1-.1 0 0 .1 0 .1-.101 0 0 .1 0 .1-.1.1 0 .1-.1.2-.1 0 0 .1 0 .1-.101l.1-.1.1-.101.1-.098 30-33 .2-.2c0-.1.1-.1.1-.2.6-.1.7-.2.7-.4zM49 39h-4.8l4.8-8.1 4.8 8.1H49zm0 6h6l-6 19.7L43 45h6zm5.2-17h7.5l-2.8 8-4.7-8zm-15.1 8l-2.8-8h7.5l-4.7 8zm-2.3 9l5.5 18.1L25.8 45h11zm24.4 0h11L55.7 63.1 61.2 45zm12-6h-9l3-8.5 6 8.5zm-42.4-8.5l3 8.5h-9l6-8.5z"
      }
    },
    custom44: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M69.7 28.9C64.4 22.3 60.1 20 51 20c-4.1 0-9 1.6-11 2 0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2h2.1c1.6 0 2.9 1.3 2.9 2.9v.1c0 1.7 1.3 3 3 3v16c-2.2 0-4 1.8-4 4v18c0 3.3 2.7 6 6 6h2c3.3 0 6-2.7 6-6V56c0-2.2-1.8-4-4-4V36c1.7 0 3-2.2 3-3.9V32c0-1.5 1.2-2.7 2.7-2.8 4-.2 6.2 1.4 7.3 2.3.6.5 1.6.6 2.2.1 1-.6 1.2-1.8.5-2.7z"
      }
    },
    custom45: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M33 43h34v14H33z"
        }, {
          "d": "M82 41.3V36c0-3.3-2.7-6-6-6H24c-3.3 0-6 2.7-6 6v5.3c0 .7.4 1.4 1 1.7 2.4 1.4 4 4 4 6.9 0 3-1.6 5.5-4 6.9-.6.4-1 1-1 1.7V64c0 3.3 2.7 6 6 6h52c3.3 0 6-2.7 6-6v-5.3c0-.7-.4-1.4-1-1.7-2.4-1.4-4-4-4-6.9 0-3 1.6-5.5 4-6.9.6-.5 1-1.1 1-1.9zM71 63H29c-1.1 0-2-.9-2-2V39c0-1.1.9-2 2-2h42c1.1 0 2 .9 2 2v22c0 1.1-.9 2-2 2z"
        }]
      }
    },
    custom46: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M61 37H39c-1.1 0-2 .9-2 2v22c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V39c0-1.1-.9-2-2-2z"
        }, {
          "d": "M78.5 27.2c.9-.3 1.5-1 1.5-1.9V22c0-1.1-.9-2-2-2h-3.3c-.9 0-1.601.6-1.9 1.5-.6 2-2.5 3.5-4.8 3.5s-4.1-1.5-4.8-3.5c-.3-.9-1-1.5-1.9-1.5h-4.6c-.9 0-1.601.6-1.9 1.5-.6 2-2.5 3.5-4.8 3.5s-4.1-1.5-4.8-3.5c-.3-.9-1-1.5-1.9-1.5h-4.6c-.9 0-1.6.6-1.9 1.5-.6 2-2.5 3.5-4.8 3.5-2.2 0-4.1-1.5-4.8-3.5-.3-.9-1-1.5-1.9-1.5H22c-1.1 0-2 .9-2 2v3.3c0 .9.6 1.6 1.5 1.9 2 .6 3.5 2.5 3.5 4.8s-1.5 4.1-3.5 4.8c-.9.3-1.5 1-1.5 1.9v4.6c0 .9.6 1.6 1.5 1.9 2 .6 3.5 2.5 3.5 4.8s-1.5 4.1-3.5 4.8c-.9.3-1.5 1-1.5 1.9v4.6c0 .9.6 1.601 1.5 1.9 2 .6 3.5 2.5 3.5 4.8s-1.5 4.1-3.5 4.8c-.9.3-1.5 1-1.5 1.9V78c0 1.1.9 2 2 2h3.3c.9 0 1.6-.6 1.9-1.5.6-2 2.5-3.5 4.8-3.5 2.2 0 4.1 1.5 4.8 3.5.3.9 1 1.5 1.9 1.5h4.6c.9 0 1.6-.6 1.9-1.5.6-2 2.5-3.5 4.8-3.5s4.1 1.5 4.8 3.5c.3.9 1 1.5 1.9 1.5h4.6c.9 0 1.601-.6 1.9-1.5.6-2 2.5-3.5 4.8-3.5s4.1 1.5 4.8 3.5c.3.9 1 1.5 1.9 1.5H78c1.1 0 2-.9 2-2v-3.3c0-.9-.6-1.601-1.5-1.9-2-.6-3.5-2.5-3.5-4.8s1.5-4.1 3.5-4.8c.9-.3 1.5-1 1.5-1.9v-4.6c0-.9-.6-1.601-1.5-1.9-2-.6-3.5-2.5-3.5-4.8s1.5-4.1 3.5-4.8c.9-.3 1.5-1 1.5-1.9v-4.6c0-.9-.6-1.6-1.5-1.9-2-.6-3.5-2.5-3.5-4.8s1.5-4.1 3.5-4.8zM69 63c0 3.3-2.7 6-6 6H37c-3.3 0-6-2.7-6-6V37c0-3.3 2.7-6 6-6h26c3.3 0 6 2.7 6 6v26z"
        }]
      }
    },
    custom47: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M64 72H30c-3.3 0-6 2.7-6 6v.1c0 1 .9 1.9 1.9 1.9h42.2c1 0 1.9-.9 1.9-1.9V78c0-3.3-2.7-6-6-6zM77.4 40.4L61.5 25.6l2.6-3.9c.4-.6.101-1.4-.6-1.5-4.9-1-7.9 2.4-7.9 2.4-30.8 0-25.8 33.9-24.3 41.8.2.899 1 1.6 2 1.6h27.1c.8 0 1.3-1 .8-1.6-5.5-6.7-8.4-14.2-10.2-19-.3-.8.5-1.7 1.3-1.3 7.3 3.7 10.3-.3 15.2 2.8 2.4 1.5 5.4 1.1 7.4-.9l2.699-2.7c.601-.8.601-2.1-.199-2.9zM57 37c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        }
      }
    },
    custom48: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M78 24H68v-2c0-1.1-.9-2-2-2H34c-1.1 0-2 .9-2 2v2H22c-1.1 0-2 .9-2 2v13c0 5 4 9 9 9h4.6c2.8 6.4 8.9 10.9 16.3 11 7.6.1 14-4.5 16.7-11H71c5 0 9-4 9-9V26c0-1.1-.9-2-2-2zM29 42c-1.7 0-3-1.3-3-3v-9h6v10.6c0 .5 0 .9.1 1.4H29zm45-3c0 1.7-1.3 3-3 3h-3.1c0-.4.1-.9.1-1.3V30h6v9zM60 74h-1c-3.3 0-6-2.7-6-6v-2c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v2c0 3.3-2.7 6-6 6h-1c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2z"
        }
      }
    },
    custom49: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M50 41c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 14c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
        }, {
          "d": "M50 20c-16.6 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30-13.4-30-30-30zm0 52.9c0 1.199-1 2.1-2.2 2-12.1-1-21.7-10.7-22.8-22.8 0-1.1.9-2.1 2.1-2.1h2c1 0 1.9.8 2 1.8.9 9 8.1 16.2 17.1 17.1 1 .1 1.8 1 1.8 2v2zm0-7.9c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm22.9-15h-2c-1 0-1.9-.8-2-1.8-.9-9-8.1-16.2-17.1-17.1-1-.1-1.8-1-1.8-2v-2c0-1.2 1-2.1 2.2-2 12.1 1 21.7 10.7 22.8 22.8 0 1.1-.9 2.1-2.1 2.1z"
        }]
      }
    },
    custom5: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M78.8 25.5c-10.2-3.9-22.1-4.8-32.5-1.4-9.3 3.1-18.8 10-20.2 20.4-.3 2.2-.2 4.5.3 6.6.2 1.101.6 2.2 1 3.301.2.6.4 1.1.7 1.6l-1.2 1.8C24 62.3 22 67.4 20.8 72.6c-.5 2.2-1.7 5.4.6 7 .9.601 2.2.601 3.1.101 1.2-.7 1.4-1.9 1.6-3.2.9-5.3 2.7-10.6 5.6-15.1 1.4-2.2 2.9-4.4 4.6-6.4 1.5-1.6 3.7-4.7 6.2-3.8 2.5.899 2.4 3.8.7 5.3s-3.1 3.1-3.1 5.5c0 1.8.8 3.6 2.3 4.8 2 1.601 6 2 8.4 1.8 5.3-.3 9.601-1.899 13.9-5C70.3 59.7 72.5 52.9 73.6 46.4c.7-4 1.2-8 2.601-11.8.6-1.6 1.399-3.2 2.3-4.6.4-.7 1.2-1.5 1.4-2.3.299-1-.301-1.9-1.101-2.2z"
      }
    },
    custom50: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M76.6 56.3C74.3 57.4 71.7 58 69 58c-3.3 0-6.3-.9-9-2.4a.912.912 0 00-1 0c-2.6 1.6-5.7 2.4-9 2.4s-6.3-.9-9-2.4a.912.912 0 00-1 0c-2.6 1.6-5.7 2.4-9 2.4-2.7 0-5.3-.6-7.6-1.7-.6-.3-1.4.2-1.4.9v12.1c0 2.4 1.4 4.5 3.6 5.5 5 2.2 10.4 3.8 16.1 4.601 1.2.199 2.3-.801 2.3-2v-7.5c0-3.301 2.7-5.9 5.9-5.9h.1c3.3 0 5.9 2.7 5.9 5.9v7.5c0 1.199 1.1 2.1 2.3 2 5.6-.801 11-2.4 16.1-4.601 2.2-1 3.601-3.1 3.601-5.5V57.2c.099-.7-.701-1.2-1.301-.9zM31 52c3.6 0 6.7-1.5 8.7-3.9.4-.5 1.1-.5 1.5 0 2 2.4 5.2 3.9 8.7 3.9 3.6 0 6.7-1.5 8.7-3.9.4-.5 1.101-.5 1.5 0 2 2.4 5.2 3.9 8.7 3.9 5.601 0 10.3-3.9 10.9-8.8.1-.7-.2-1.4-.8-1.8l-25.3-20c-2.199-1.7-5.3-1.7-7.399 0l-25.5 20c-.6.4-.8 1.1-.8 1.8C20.7 48.2 25.4 52 31 52z"
        }
      }
    },
    custom51: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M40.5 25.6c2.5 1.7 5 5.8 6 8.9.2.7.8 1.2 1.5 1.3.7.2 1.3.2 2 .2 1.1 0 2 0 2.9-.4 2.6-.9 4.8-2 6.699-3.9 3.101-3.1 4.2-7.5 3-11.2-3.699-1.1-8.1-.1-11.199 3-.9.9-1.601 1.9-2.2 3-1.6-2.5-3.5-4.7-5.7-6.1-1.5-.9-3.4-.4-4.3 1.1-.6 1.5 0 3.2 1.3 4.1zM71.2 40.2c-10.3-5.8-12.5 2-21.2 2s-10.9-7.8-21.2-2c-10 5.7-7.1 24.1-3.1 31 3.6 6.1 10.1 12.4 23.4 6.4.5-.199 1.2-.199 1.7 0 13.3 6 19.9-.3 23.4-6.399 4.1-6.901 7-25.401-3-31.001z"
        }
      }
    },
    custom52: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M79.9 35.1c.199-3.2 0-6.4-.5-9.5-.4-2.6-2.4-4.6-5-5-3.2-.5-6.301-.7-9.5-.5-.9 0-1.301 1.1-.7 1.7l14 14c.6.6 1.7.1 1.7-.7zM56.3 22.3c-.5-.5-1.3-.7-1.899-.5-7.5 2.1-14.7 6.1-20.601 12.1-5.8 5.8-9.7 12.7-11.9 20-.2.699 0 1.5.5 2l21.8 21.8c.5.5 1.3.7 2 .5 7.3-2.2 14.2-6.101 20-11.9 5.899-5.899 10-13 12.1-20.6.2-.7 0-1.4-.5-1.9L56.3 22.3zm-8.4 39.3c-1.2 1.2-3.1 1.2-4.2 0L38.1 56c-1.2-1.2-1.2-3.1 0-4.2 1.2-1.2 3.1-1.2 4.2 0l5.6 5.601c1.2 1.099 1.2 2.999 0 4.199zm7-7c-1.2 1.2-3.101 1.2-4.2 0L45.1 49c-1.2-1.2-1.2-3.1 0-4.2 1.2-1.2 3.1-1.2 4.2 0l5.601 5.6c1.199 1.1 1.199 3-.001 4.2zm7-7.1c-1.2 1.2-3.101 1.2-4.2 0l-5.6-5.6c-1.199-1.2-1.199-3.1 0-4.2 1.2-1.2 3.101-1.2 4.2 0l5.601 5.6c1.199 1.2 1.199 3.1-.001 4.2zM20.1 64.3c-.2 3.4-.1 6.8.5 10.2.4 2.6 2.4 4.6 5 5 3.4.5 6.8.7 10.2.5.9-.1 1.3-1.1.7-1.7L21.8 63.6c-.6-.6-1.7-.2-1.7.7z"
        }
      }
    },
    custom53: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M74.7 57h-.6c-2.3 0-4.1-1.8-4.1-4.1V39.7c0-11.6-10.4-20.9-22.3-19.5C37.5 21.3 30 30.2 30 40.5v11.9c0 2.5-2.1 4.6-4.6 4.6h-.1c-1.8 0-3.3 1.5-3.3 3.3v2.4c0 1.8 1.5 3.3 3.3 3.3h49.4c1.8 0 3.3-1.5 3.3-3.3v-2.4c0-1.8-1.5-3.3-3.3-3.3zM56.6 72H43.4c-.8 0-1.5.6-1.3 1.4.7 3.8 4 6.6 8 6.6s7.2-2.7 8-6.6c0-.8-.6-1.4-1.5-1.4z"
        }
      }
    },
    custom54: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M27.2 49.1c6.5-1.2 12.2-3.8 18.4-6.7 2-.9 5.7-2.7 7.5-3.5.601-.3 1-.9.801-1.6C53.4 34.4 51 32 48 32h-2v-3.8c0-1.1-1-2.1-2-2.1V22c0-1.1-.9-2.1-2-2.1h-4c-1.1 0-2 .9-2 2.1v4.1c-1 0-2 .9-2 2.1V32h-2c-3.3 0-6 3.1-6 6.5v9.6c0 .6.6 1.1 1.2 1zM72 69.2s7.3-11.4 8-27.5c0-1.2-.9-2.2-2.1-2.2-23.8.9-34.9 15.5-56 16.4-1.1 0-1.9 1-1.9 2v7.6c0 3.3 2.5 5.9 5.6 6.1 10.5.7 33 2.2 45.9 4.301 1.3.199 2.5-1 2.3-2.301-.3-1.5-.8-3.3-1.8-4.4zM71 51c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        }
      }
    },
    custom55: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M32 61h13c1.1 0 2-.9 2-2V29c0-2.2-2-4-4-4H32.3C31 25 30 26 30 27.3V59c0 1.1.9 2 2 2z"
        }, {
          "d": "M76 31v32c0 2.2-1.8 4-4 4H28c-2.2 0-4-1.8-4-4V31c-3.3 0-6 2.7-6 6v30c0 3.3 2.7 6 6 6h19c1.1 0 2 .9 2 2s.9 2 2 2h6c1.1 0 2-.9 2-2s.9-2 2-2h19c3.3 0 6-2.7 6-6V37c0-3.3-2.7-6-6-6z"
        }, {
          "d": "M55 61h12.7c1.3 0 2.3-1 2.3-2.3V27c0-1.1-.9-2-2-2H57c-2 0-4 1.8-4 4v30c0 1.1.9 2 2 2z"
        }]
      }
    },
    custom56: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M62.7 30.3c-6.3 6.3-13.9-1.4-20.9 5.6L21.7 56c-2.3 2.3-2.3 6 0 8.3l7 7 7 7c2.3 2.3 6 2.3 8.3 0l20.2-20.2c7-7-.7-14.6 5.6-20.899l1.601-1.6c.399-.4.399-1 0-1.4l-5.5-5.5c-.4-.4-1-.4-1.4 0L62.7 30.3zM57.9 56l-7 7c-.8.8-2 .8-2.8 0l-5.6-5.6-5.6-5.6c-.8-.8-.8-2 0-2.8l7-7c.8-.8 2-.8 2.8 0l5.6 5.6 5.601 5.6c.799.8.799 2-.001 2.8zM79.4 24.7l-2.1-2.1-2.1-2.1c-.8-.8-2-.8-2.8 0l-2.6 2.6c-.399.4-.399 1 0 1.4l5.5 5.5c.4.4 1 .4 1.4 0l2.6-2.6c.9-.6.9-1.9.1-2.7z"
        }
      }
    },
    custom57: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M53 52.6V77c0 .8.8 1.2 1.5.9 4.8-2.7 19.4-11 19.4-11 1.9-1.1 3.1-3.1 3.1-5.3V39.7c0-.8-.8-1.2-1.5-.9L54 50.9c-.6.4-1 1-1 1.7zM51 45.8l21.6-12.1c.7-.4.7-1.3 0-1.7-4.8-2.7-19.5-11.1-19.5-11.1a6.237 6.237 0 00-6.2 0S32.2 29.2 27.4 32c-.7.4-.7 1.3 0 1.7L49 45.8c.6.3 1.4.3 2 0zM46 50.9L24.5 38.8c-.7-.4-1.5.1-1.5.9v21.8c0 2.2 1.2 4.2 3.1 5.3 0 0 14.6 8.3 19.4 11 .7.4 1.5-.1 1.5-.899V52.6c0-.7-.4-1.3-1-1.7z"
        }
      }
    },
    custom58: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M67 46c-1.7 0-3.1-1.4-3-3.2.1-1.6 1.5-2.8 3.2-2.8h8.6c.4 0 .7-.2.9-.5.8-1.4 1.399-2.8 1.899-4.1.201-.7-.199-1.4-.899-1.4h-6.4c-1.6 0-3.1-1.2-3.2-2.8-.1-1.7 1.3-3.2 3-3.2h8c.601 0 1-.4 1-1v-3c0-1.1-.899-2-2-2H67.4c-3 0-5.4 2.4-5.4 5.4v.1c0 5.6-3.7 10.6-9 12v-8.3c2.1-1.2 3.4-3.5 3-6.2-.4-2.6-2.6-4.7-5.2-5-3.6-.4-6.7 2.4-6.7 6 0 2.2 1.2 4.1 3 5.2v8.4c-5.3-1.4-9-6.4-9-12v-.1c0-3-2.4-5.4-5.4-5.4H22c-1.1 0-2 .9-2 2v3c0 .6.4 1 1 1h7.8c1.6 0 3.1 1.2 3.2 2.8.1 1.7-1.3 3.2-3 3.2h-6.5c-.7 0-1.2.7-.9 1.4.5 1.3 1.1 2.7 1.9 4.1.2.3.5.5.9.5H33c1.6 0 3.1 1.2 3.2 2.8.1 1.7-1.3 3.2-3 3.2h-2.4c-.9 0-1.4 1.2-.6 1.8 4.2 3.6 9.8 6.2 17 6.2v22.8c0 1.6 1.2 3.1 2.8 3.199 1.7.101 3.2-1.3 3.2-3V54c7.2 0 12.8-2.6 17-6.2.7-.6.3-1.8-.601-1.8H67z"
      }
    },
    custom59: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M68.3 31c1 0 1.7-.8 1.7-1.7 0-.7-.4-1.4-1.1-1.8-1.301-.7-3.301-4.1-4-6.2-.2-.8-1-1.3-1.801-1.3H38.8c-.8 0-1.6.5-1.8 1.3-.6 2-2.7 5.5-3.9 6.2-.6.4-1 1-1 1.8 0 1 .8 1.7 1.7 1.7h34.5zM32 73.9c0 3.399 2.7 6.1 6 6.1h26c3.3 0 6-2.7 6-6v-.1c0-1.101-.9-1.9-1.9-1.9H33.9c-1 0-1.9.9-1.9 1.9zM70 64V39c0-1.1-.9-2-2-2H34c-1.1 0-2 .9-2 2v25c0 1.1.9 2 2 2h34c1.1 0 2-.9 2-2z"
        }
      }
    },
    custom6: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M50 76H24c-3.1 0-5-3.4-3.4-6l26-44c1.5-2.6 5.3-2.6 6.9 0l26 44c1.6 2.7-.4 6-3.4 6H50z"
      }
    },
    custom60: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M80 45.3C77.6 31 65.1 20 50 20S22.4 31 20 45.3c-.2.9.9 1.6 1.6 1 1.5-1.3 3.4-2 5.6-2 2.8 0 5.2 1.3 6.8 3.3.4.5 1.2.5 1.6 0 1.6-2 4-3.3 6.8-3.3s5.2 1.3 6.8 3.3c.4.5 1.2.5 1.6 0 1.601-2 4-3.3 6.8-3.3 2.801 0 5.2 1.3 6.801 3.3.399.5 1.199.5 1.6 0 1.6-2 4-3.3 6.8-3.3 2.101 0 4.101.8 5.601 2 .698.6 1.698 0 1.598-1zM62 68c-1.7 0-3 1.3-3 3s-1.3 3-3 3-3-1.3-3-3V57c0-1.7-1.3-3-3-3s-3 1.3-3 3v14c0 5 4 9 9 9s9-4 9-9c0-1.7-1.3-3-3-3z"
        }
      }
    },
    custom61: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M73 20h-4c-1.1 0-2 .9-2 2v4c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-4c0-1.1-.8-2-2-2h-4c-1.1 0-2 .9-2 2v4c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v4c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v10c0 3.3 2.7 6 6 6h38c3.3 0 6-2.7 6-6V22c0-1.1-.9-2-2-2zM68.5 45.7c-.1-1-1-1.7-2-1.7h-33c-1 0-1.9.7-2 1.7l-4.5 32c-.2 1.2.8 2.3 2 2.3h12.9c1.1 0 2.1-.9 2.1-2v-9.7c0-3.3 2.5-6.2 5.8-6.2 3.4-.1 6.2 2.601 6.2 6v10c0 1.101 1 2 2.1 2H71c1.2 0 2.2-1.1 2-2.3l-4.5-32.1z"
        }
      }
    },
    custom62: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M77 70H23c-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3h54c1.6 0 3-1.3 3-3s-1.3-3-3-3zM24 64h34v-4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v4h4c1.1 0 2-.9 2-2V28c0-1.1-.9-2-2-2H24c-1.1 0-2 .9-2 2v34c0 1.1.9 2 2 2zm9-26c0-1.1.9-2 2-2h29c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H35c-1.1 0-2-.9-2-2v-2zm0 12c0-1.1.9-2 2-2h19c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H35c-1.1 0-2-.9-2-2v-2z"
        }
      }
    },
    custom63: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M42 60h16c1.1 0 2-.9 2-2V42c0-1.1-.9-2-2-2H42c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2z"
        }, {
          "d": "M77 53c1.7 0 3-1.3 3-3s-1.3-3-3-3h-5v-6h5c1.7 0 3-1.3 3-3s-1.3-3-3-3h-5v-1c0-3.3-2.7-6-6-6h-1v-5c0-1.7-1.3-3-3-3s-3 1.3-3 3v5h-6v-5c0-1.7-1.3-3-3-3s-3 1.3-3 3v5h-6v-5c0-1.7-1.3-3-3-3s-3 1.3-3 3v5h-1c-3.3 0-6 2.7-6 6v1h-5c-1.7 0-3 1.3-3 3s1.3 3 3 3h5v6h-5c-1.7 0-3 1.3-3 3s1.3 3 3 3h5v6h-5c-1.7 0-3 1.3-3 3s1.3 3 3 3h5v1c0 3.3 2.7 6 6 6h1v5c0 1.7 1.3 3 3 3s3-1.3 3-3v-5h6v5c0 1.7 1.3 3 3 3s3-1.3 3-3v-5h6v5c0 1.7 1.3 3 3 3s3-1.3 3-3v-5h1c3.3 0 6-2.7 6-6v-1h5c1.7 0 3-1.3 3-3s-1.3-3-3-3h-5v-6h5zM66 63c0 1.7-1.3 3-3 3H37c-1.7 0-3-1.3-3-3V37c0-1.7 1.3-3 3-3h26c1.7 0 3 1.3 3 3v26z"
        }]
      }
    },
    custom64: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M50 20c-16.5 0-30 13.5-30 30s13.5 30 30 30 30-13.5 30-30-13.5-30-30-30zm0 52c-12.1 0-22-9.9-22-22s9.9-22 22-22 22 9.9 22 22-9.9 22-22 22z"
        }, {
          "d": "M61.6 37.1l-16.6 6c-.9.3-1.6 1-1.9 1.9l-6 16.6c-.3.8.5 1.6 1.3 1.3l16.6-6c.9-.301 1.6-1 1.9-1.9l6-16.6c.3-.8-.5-1.6-1.3-1.3zM50 54c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
        }]
      }
    },
    custom65: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M72.1 67H21.9c-1 0-1.9.9-1.9 1.9v.1c0 3.3 2.7 6 6 6h42c3.3 0 6-2.7 6-6v-.1c0-1-.9-1.9-1.9-1.9zM70 27H22.1c-1 0-1.8.9-1.9 2-.3 2.7-.3 7.5.1 10.4 1.3 9.3 6.3 17.2 13.2 21.4.3.2.7.3 1 .3h20.9c.399 0 .699-.1 1-.3 3.899-2.399 7.3-6 9.6-10.4 1.2.4 2.5.6 3.9.6 6.6 0 12-5.4 12-12S76.6 27 70 27zm0 18c-.5 0-1-.1-1.5-.2 1-3.2 1.5-6.6 1.5-10.2V33c3.3 0 6 2.7 6 6s-2.7 6-6 6z"
        }
      }
    },
    custom66: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M78.3 55.3L63.7 40.7c-2.3-2.3-6-2.3-8.3 0L40.7 55.3c-2.3 2.3-2.3 6 0 8.3l14.6 14.6c2.3 2.3 6 2.3 8.3 0l14.6-14.6c2.4-2.2 2.4-6 .1-8.3zM50.7 62c-1.4 1.4-3.6 1.4-4.9 0-1.4-1.4-1.4-3.6 0-4.9 1.4-1.399 3.6-1.399 4.9 0 1.3 1.3 1.3 3.5 0 4.9zM62 73.3c-1.4 1.4-3.6 1.4-4.9 0-1.4-1.4-1.4-3.6 0-4.9 1.4-1.4 3.601-1.4 4.9 0 1.3 1.3 1.3 3.5 0 4.9zm0-22.6c-1.4 1.399-3.6 1.399-4.9 0-1.399-1.4-1.399-3.6 0-4.9 1.4-1.4 3.601-1.4 4.9 0 1.3 1.3 1.3 3.5 0 4.9zM73.3 62c-1.399 1.4-3.6 1.4-4.899 0-1.4-1.4-1.4-3.6 0-4.9 1.399-1.4 3.599-1.4 4.899 0 1.4 1.3 1.4 3.5 0 4.9zM53 33.5V26c0-3.3-2.7-6-6-6H26c-3.3 0-6 2.7-6 6v21c0 3.3 2.7 6 6 6h7.5c.6 0 1.2-.3 1.6-.7.3-.399.7-.8 1.1-1.2L51 36.2c.4-.4.8-.7 1.2-1.1.5-.4.8-1 .8-1.6zM28.5 48c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm8-8c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm8-8c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
        }
      }
    },
    custom67: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M54 53.1L52.8 51c-.5-.8-1.3-1.3-2.2-1.3-.3 0-.6.1-.899.2l-3.5 1.3c-1.4-1.2-2.9-2-4.6-2.6L41 45c-.2-1.2-1.3-1.9-2.5-1.9H36c-1.2 0-2.3.7-2.5 2l-.6 3.5c-1.7.6-3.2 1.5-4.6 2.7L24.8 50c-.3-.1-.6-.2-.9-.2-.9 0-1.8.5-2.2 1.3l-1.2 2.1c-.6 1.1-.4 2.399.6 3.2l2.9 2.4c-.2.9-.3 1.8-.3 2.601 0 .8.1 1.8.3 2.699l-2.9 2.4c-1 .8-1.2 2.2-.6 3.2l1.2 2.1c.5.8 1.3 1.3 2.2 1.3.3 0 .6-.1.9-.199l3.5-1.301c1.4 1.2 2.9 2.101 4.6 2.601l.6 3.7C33.7 79.1 34.8 80 36 80h2.5c1.2 0 2.3-.9 2.5-2.1l.6-3.7c1.8-.601 3.4-1.601 4.8-2.8l3.3 1.3c.3.1.6.2.899.2.9 0 1.7-.5 2.2-1.2l1.2-2c.6-1.101.4-2.5-.6-3.3L50.5 64c.2-.9.3-1.8.3-2.6 0-.9-.1-1.801-.3-2.7l2.9-2.4c.9-.8 1.2-2.2.6-3.2zM37.2 68.3c-3.7 0-6.8-3-6.8-6.8s3-6.8 6.8-6.8c3.7 0 6.8 3 6.8 6.8s-3.1 6.8-6.8 6.8zM79.2 39l-2.3-1.9c.1-.7.2-1.4.2-2.1s-.1-1.5-.2-2.1l2.3-1.9c.8-.6 1-1.7.5-2.6l-1-1.7c-.4-.6-1.101-1-1.8-1-.2 0-.5.1-.7.1l-2.9 1.1c-1.1-1-2.399-1.7-3.7-2.1l-.5-3c-.199-1-1-1.6-2-1.6h-2c-1 0-1.899.6-2 1.6l-.5 2.9c-1.4.5-2.6 1.2-3.7 2.2L56 25.6c-.2-.1-.5-.1-.7-.1-.7 0-1.399.4-1.8 1l-1 1.7c-.5.9-.3 2 .5 2.6l2.3 1.9c-.1.7-.2 1.4-.2 2.1 0 .7.101 1.5.2 2.1L53 38.8c-.8.6-1 1.7-.5 2.6l1 1.7c.4.6 1.1 1 1.8 1 .2 0 .5 0 .7-.1l2.9-1.1c1.1 1 2.399 1.7 3.699 2.1l.5 2.9c.2 1 1 1.7 2 1.7h2c1 0 1.9-.7 2-1.7l.5-3c1.4-.5 2.801-1.3 3.9-2.3l2.7 1.1c.2.1.5.1.7.1.699 0 1.399-.4 1.8-1l1-1.6c.501-.4.301-1.5-.499-2.2zm-13.1 1.6c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5 5.5 2.5 5.5 5.5-2.4 5.5-5.5 5.5z"
        }
      }
    },
    custom68: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M50 20c-16.5 0-30 13.5-30 30s13.5 30 30 30 30-13.5 30-30-13.5-30-30-30zm23.8 27h-7.9c-.3-7.1-1.9-13.3-4.3-18 6.6 3.7 11.2 10.3 12.2 18zM47 27.3V47h-6.9c.5-9.4 3.5-16.8 6.9-19.7zM47 53v19.7c-3.4-2.9-6.4-10.3-6.9-19.7H47zm6 19.7V53h6.9c-.5 9.4-3.5 16.8-6.9 19.7zM53 47V27.3c3.4 2.9 6.4 10.3 6.9 19.7H53zM38.4 29c-2.4 4.7-3.9 10.9-4.3 18h-7.9c1-7.7 5.6-14.3 12.2-18zM26.2 53h7.9c.3 7.1 1.9 13.3 4.3 18-6.6-3.7-11.2-10.3-12.2-18zm35.4 18c2.4-4.7 3.9-10.9 4.301-18H73.8c-1 7.7-5.6 14.3-12.2 18z"
      }
    },
    custom69: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M52.6 45.1c-5.7-4.3-11.5-2.2-15.3 1.4-1.4 1.3-3.6 2.1-6 2.8-2.8.9-5.7 1.8-7.8 3.9-5.6 5.5-4.5 12.1 3.3 19.8l.1.1.1.1c4.6 4.5 8.8 6.7 12.6 6.7 2.8 0 5.3-1.101 7.7-3.4 2.1-2 3.1-4.9 4-7.6.8-2.3 1.6-4.6 2.9-5.9 2.3-2.2 3.6-4.8 3.899-7.4.201-1.9-.199-4.6-2.399-7.4 0 0-1.2-1.6-3.1-3.1zM40.2 69.2c-.5.5-1.2.8-2 .8s-1.4-.3-1.9-.8l-5.5-5.5c-1.1-1.101-1.1-2.8 0-3.9s2.8-1.1 3.9 0l5.5 5.5c1.1 1.1 1.1 2.8 0 3.9zM45 61c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zM79.4 25.2l-4.6-4.6c-.8-.8-2.2-.8-3.1 0l-5.1 5.1c-.8.8-.8 2.2 0 3.1l.2.2-10.3 10.3c-.4.4-.4 1.1 0 1.5.8.7 2.1 1.9 2.9 2.7.399.4 1 .4 1.399 0L71 33.3l.2.2c.8.8 2.2.8 3.1 0l5.101-5.1c.799-.9.799-2.3-.001-3.2z"
        }
      }
    },
    custom7: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M28 78c-3.3 0-6-2.7-6-6V28c0-3.3 2.7-6 6-6h44c3.3 0 6 2.7 6 6v44c0 3.3-2.7 6-6 6H28z"
      }
    },
    custom70: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M47.9 63.8L36.4 52.5c-2.4-2.3-6.2-2.3-8.6 0l-7.2 7.1c-.8.801-.8 2.101 0 2.801L22 63.8l1.4 1.4L35 76.6l.7.7 2.2 2.101c.8.8 2.1.8 2.9 0L48 72.3c2.3-2.3 2.3-6.1-.1-8.5zm-18.7-4.2l1.5-1.399c.8-.8 2-.8 2.8 0l8.7 8.5c.8.8.8 2.1 0 2.8l-1.5 1.4c-.8.8-2 .8-2.8 0l-8.7-8.5c-.8-.801-.8-2.101 0-2.801zM41.7 49.2l9.3 9.1c.2.2.4.3.7.3l4.3-.1c.5 0 .9-.4.9-.9l.1-3.7c0-.5.4-.9.9-.9l3.8-.1c.5 0 .899-.4.899-.9l.101-3.7c0-.5.399-.9.899-.9l3.801-.1c.5 0 .899-.4.899-.9l.101-3.7c0-.5.399-.9.899-.9l3.8-.1c.5 0 .9-.4.9-.9l.1-3.8c0-.5.4-.8.801-.9l4.1-.6c.7-.1 1.1-.9.7-1.5l-8.8-13c-.7-1-2.101-1.1-3-.3l-26.3 26c-.6.6-.6 1.8.1 2.5z"
        }
      }
    },
    custom71: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M71.2 30.8c-5.9-5.9-13.8-9-22.1-8.8-16 .5-29.1 14.2-29.1 30.6V62c0 3.3 2.7 6 6 6h4v4.8c0 2.601 1.9 4.9 4.5 5.2 3 .3 5.5-2.1 5.5-5V55.2c0-2.601-1.9-4.9-4.5-5.2-3-.3-5.5 2.1-5.5 5v7h-2c-1.1 0-2-.9-2-2v-7.4C26 39.4 36.5 28.4 49.3 28c6.601-.2 12.7 2.2 17.4 6.8C71.4 39.4 74 45.5 74 52v8c0 1.1-.9 2-2 2h-2v-6.8c0-2.601-1.9-4.9-4.5-5.2-3-.3-5.5 2.1-5.5 5v17.8c0 2.601 1.9 4.9 4.5 5.2 3 .3 5.5-2.1 5.5-5v-5h4c3.3 0 6-2.7 6-6v-9.4c0-8.1-3-16-8.8-21.8z"
      }
    },
    custom72: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M77 20H23c-1.7 0-3 1.3-3 3s1.3 3 3 3h24v6.2c-10.8 1.4-19 10.6-19 21.7v6.9C28 68.1 33.8 74 41.2 74h17.7C66.2 74 72 68.1 72 60.7v-6.9c0-11.1-8.2-20.3-19-21.7V26h24c1.7 0 3-1.3 3-3s-1.3-3-3-3zM64 53.8c0 .1 0 0 0 0 0 2.9-2.3 5.2-5.2 5.2H41.2c-2.9 0-5.1-2.3-5.2-5.2v.1-.1.101C36.1 46.2 42.2 40 49.8 40h.4c7.6 0 13.7 6.2 13.8 13.8z"
        },
        "circle": [{
          "cx": "26",
          "cy": "76",
          "r": "4"
        }, {
          "cx": "74",
          "cy": "76",
          "r": "4"
        }]
      }
    },
    custom73: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M23.5 35h53c1.3 0 2.3-1.3 1.9-2.5-1.2-4.1-3-7.9-5.4-11.2-.7-1-2.1-1.1-2.9-.3-2.4 2.2-5.7 3.5-9.2 3.5-3.7 0-7.101-1.5-9.601-4-.8-.7-2-.7-2.7 0-2.5 2.5-5.9 4-9.6 4-3.5 0-6.7-1.3-9.2-3.5-.9-.8-2.2-.6-2.9.3-2.4 3.3-4.2 7.1-5.4 11.2C21.2 33.7 22.2 35 23.5 35zM80 43c0-1.1-.9-2-2-2H22c-1.1 0-2 .9-2 2v.4C20 62 33 77.5 50 79.9 67 77.5 80 62 80 43.4V43z"
        }
      }
    },
    custom74: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M56 73H46c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zM51 20c-12.2 0-22 9.4-22 21 0 7.5 4.1 14.1 10.4 17.8 2.4 1.4 4 3.8 4.5 6.5.2.9 1 1.601 2 1.601h10.4c1 0 1.8-.7 2-1.601.5-2.7 2.101-5.1 4.5-6.5C68.9 55.1 73 48.5 73 41c0-11.6-9.8-21-22-21zm-6.8 9.4c-2 3.8-3.1 8.3-3.2 11.9 0 3.7.7 7.3 2 10.8.4.9-.5 1.7-1.4 1.301C32.4 48.7 33 31.4 43 28c.8-.3 1.6.6 1.2 1.4zm7.7 23.8c-.301.8-1.5.8-1.8 0-1.6-3.9-2-8.5-2.1-12.7.1-4.2.5-8.8 2.1-12.7.3-.8 1.5-.8 1.8 0 1.6 3.9 2 8.5 2.1 12.7-.1 4.2-.5 8.8-2.1 12.7zm8.1.2c-.8.4-1.7-.4-1.4-1.3 1.4-3.6 2-7.6 2.101-11.399-.101-3.2-1.2-7.6-3.2-11.3-.4-.8.4-1.7 1.2-1.4C68.7 31.4 69.3 48.7 60 53.4z"
        }
      }
    },
    custom75: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M50 20c-1.7 0-3 1.3-3 3v54c0 1.7 1.3 3 3 3 16.5 0 30-13.5 30-30S66.5 20 50 20zm23.8 27h-7.9c-.3-7.1-1.9-13.3-4.3-18 6.6 3.7 11.2 10.3 12.2 18zM53 72.7V53h6.9c-.5 9.4-3.5 16.8-6.9 19.7zM53 47V27.3c3.4 2.9 6.4 10.3 6.9 19.7H53zm8.6 24c2.4-4.7 3.9-10.9 4.301-18H73.8c-1 7.7-5.6 14.3-12.2 18zM33.5 39.9c.8.6 2 .5 2.7-.3l5.5-6.2c.7-.8.7-2-.1-2.7l-5.5-5.5c-.7-.7-1.7-.8-2.5-.3-.4.2-.7.5-1.1.7C25 31 20 39.9 20 50c0 10.1 5 19 12.5 24.4.4.3.7.5 1.1.699.8.5 1.8.4 2.5-.3l5.5-5.5c.7-.7.8-2 .1-2.7L36.2 60.4c-.7-.801-1.9-.9-2.7-.301L31.4 61.7C29.2 58.3 28 54.3 28 50s1.2-8.3 3.4-11.7l2.1 1.6z"
        }
      }
    },
    custom76: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M52.9 55.3c-.3-.8-1.1-1.4-2-1.3H50c-11 0-20-9-20-20v-.5c0-1-1.3-1.4-1.8-.6-.7 1-1.2 2.2-1.6 3.5-1.7 5.7.5 11.9 5.3 15.4 2.2 1.601 4.5 2.3 6.9 2.601l.7 1.899c.1.3.3.5.5.601l3 1.3c.5.2.7.8.5 1.3l-1 2.9c-.2.5.1 1 .5 1.199l1.6.7c.5.2.7.8.5 1.3l-.9 3.1c-.1.5.1 1 .5 1.2l2.3 1c.5.199.7.8.5 1.3l-.8 3.1c-.1.5.1 1 .6 1.2l6.8 3.1c.5.2 1.101 0 1.301-.5l3-6.699c.199-.5.199-1 .1-1.5L52.9 55.3z"
        }, {
          "d": "M79.4 54.3L63.5 37.7c.7-2.5.7-5.2-.3-8.1-1.9-5.3-6.8-9.2-12.5-9.5-8.6-.4-15.6 6.9-14.7 15.6.7 6 5.2 10.9 11.1 12.1 2.6.5 5.1.3 7.4-.5l1.4 1.5c.2.2.4.3.7.3H60c.6 0 1 .4 1 1l.3 3.1c0 .5.5.899 1 .899H64c.6 0 1 .4 1 1l.5 3.2c.1.5.5.8 1 .8H69c.6 0 1 .4 1 1l.5 3.2c.1.5.5.8 1 .8H79c.6 0 1-.399 1-1v-7.3c0-.699-.2-1.199-.6-1.499zM48 37c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.2 5-5 5z"
        }]
      }
    },
    custom77: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M32 42h4c.6 0 1-.4 1-1v-1.5C37 31.9 42.7 26 50 26s13 5.9 13 13.5V41c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-1.5C69 28.6 60.7 20 50 20s-19 8.6-19 19.5V41c0 .6.4 1 1 1zM70 48H31c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h39c3.3 0 6-2.7 6-6V54c0-3.3-2.7-6-6-6zM55.3 64.1c-.899 1.4-1.399 3-1 4.601l.7 3c.2 1.1-.6 2.3-1.8 2.3h-6.4c-1.2 0-2-1.2-1.8-2.3l.7-3.101c.4-1.6-.1-3.199-1-4.5-.9-1.3-1.3-2.899-1-4.5.5-2.399 2.5-4.3 5-4.8 4.1-.8 7.6 2.2 7.6 5.9 0 1.3-.4 2.4-1 3.4z"
        }
      }
    },
    custom78: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M78.3 29.3l-18-9c-.8-.4-1.8-.4-2.7 0L41 28.6l-16.7-8.3c-.9-.5-2-.4-2.9.1C20.5 21 20 22 20 23v45c0 1.1.6 2.2 1.7 2.7l18 9c.8.399 1.8.399 2.7 0L59 71.4l16.7 8.3c.4.2.9.3 1.3.3.5 0 1.1-.2 1.6-.4C79.5 79 80 78 80 77V32c0-1.1-.6-2.2-1.7-2.7zM74 35.1v23.7c0 1.4-1.4 2.4-2.7 1.9-4.6-1.8-1-9.5-4.3-13.7-3.1-3.9-7.2.1-11-6-3.7-5.9 1.3-10.1 5.7-12.4.6-.3 1.2-.3 1.8 0l9.3 4.7c.8.3 1.2 1 1.2 1.8zM48.5 69.9c-.7.399-1.6.3-2.2-.301C45 68.5 44 66.7 44 65c0-3-5-2-5-8 0-4.8-5.9-6.2-10.8-5.7-1.2.1-2.2-.8-2.2-2V31.1c0-1.5 1.6-2.5 2.9-1.8l10.8 5.4c.1 0 .2.1.3.1l.4.2c4.5 2.6 3.6 4.8 1.7 8-2.1 3.6-3 0-6-1s-6 1-5 3 4 0 6 2 2 5 8 3 7-1 9 1 3 6 0 9c-1.8 1.8-2.5 5.4-3.3 8-.2.5-.5 1-1 1.3l-1.3.6z"
      }
    },
    custom79: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M39 41c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"
        }, {
          "d": "M79 63H60v-8h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-2.3c-1.601-10-10-17.8-20.4-18-11.8-.2-21.5 9.5-21.3 21.3.2 11.6 9.9 20.7 21.5 20.7H76v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-5c0-1.7-1.3-3-3-3zm-40-2c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13z"
        }]
      }
    },
    custom8: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M47 21.3l-24 26c-1.4 1.5-1.4 3.9 0 5.4l24 26c1.6 1.7 4.3 1.7 5.9 0l24-26c1.399-1.5 1.399-3.9 0-5.4l-24-26a4.05 4.05 0 00-5.9 0z"
      }
    },
    custom80: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M29 60c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM71 60c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
        }, {
          "d": "M70.4 54c2.199-.1 4.3.3 6.3 1 1 .4 2.1-.1 2.6-1 5.101-9.7-3.1-14.2-8.3-16.8-1.4-.6-3 .3-3 1.8v5.8c0 1.2-.8 2.4-2 2.2-7.4-1.2-14-9-22-9s-9 8-9 8c-5.6 0-11.1-.4-13.6-1-1.2-.3-2.4.7-2.4 2 0 0 0 7 10 7 8.2 0 15 6 15.9 14.2.2 2.2 0 4.399-.6 6.3-.2.7.3 1.4 1.1 1.4h9.2c.801 0 1.301-.7 1.101-1.4-.601-1.9-.8-3.9-.601-6 .7-7.8 7.3-14.2 15.3-14.5zM19 47zM45.3 31.5c.1.8.7 1.5 1.4 1.7l10.6 3.6c1 .3 2-.1 2.5-1l.9-1.7c.399-.7-.101-1.5-.8-1.6-3.101-.3-9.601-1.5-7.7-5 1.7-3 5.2-2.2 7.5-1.2.899.4 1.8-.6 1.399-1.5-1.5-3.2-5-5.2-8.699-4.8-4.7.5-8 5.1-7.4 9.8l.3 1.7z"
        }]
      }
    },
    custom81: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M76.9 20c-1 0-3.9.1-4.9.1-15.4.8-33.1 4.6-34 4.9-1.2.4-2 1.6-2 2.8v32.6c-1-.4-2.6-.6-4-.6-6.6 0-12 4.5-12 10s5.4 10 12 10 12-4.5 12-10V49.4c0-.9.6-1.7 1.5-1.9 4.9-1.2 11.7-2.5 24.4-3.3 1.199-.1 2.1.8 2.1 2v10.3c-1-.4-2.6-.6-4-.6-6.6 0-12 4.5-12 10s5.4 10 12 10 12-4.5 12-10V23c0-1.7-1.4-3.1-3.1-3zm-6.8 15.8c-12.2.7-18.4 1.9-23.7 3.1-1.3.3-2.4-.7-2.4-2v-3.1c0-.9.6-1.7 1.6-2 5.2-1.2 11.5-2.5 24.3-3.3 1.199-.1 2.1.8 2.1 2v3.2c0 1.2-.8 2.1-1.9 2.1z"
      }
    },
    custom82: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M80 44H59c-1.1 0-2 .9-2 2v1c0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3v-1c0-1.1-.9-2-2-2h-5 .1c-5.9.3-11 3.7-13.8 8.6-1-.399-2.1-.6-3.2-.6-5 0-9 4-9 9s4 9 9 9c1.1 0 2.2-.2 3.2-.6 2.8 4.899 8 8.3 13.8 8.6 9.8.5 17.9-7.3 17.9-17 0-.6 0-1.2-.1-1.8-.101-1 .6-2 1.6-2.2l16.9-3.7c.899-.2 1.6-1 1.6-2V46c0-1.1-.9-2-2-2zM27 64c-1.7 0-3-1.3-3-3s1.3-3 3-3c.4 0 .9.1 1.2.3-.2 1.2-.2 2.5-.2 3.8 0 .601.1 1.101.2 1.601-.4.199-.8.299-1.2.299zM54 37c1.7 0 3-1.3 3-3v-9c0-1.7-1.3-3-3-3s-3 1.3-3 3v9c0 1.7 1.3 3 3 3zM39.7 38c.6.7 1.4 1 2.3 1 .7 0 1.4-.2 2-.7 1.3-1.1 1.4-3 .3-4.2l-6-7c-1.1-1.3-3-1.4-4.2-.3-1.3 1.1-1.4 3-.3 4.2l5.9 7zM66 39c.8 0 1.7-.4 2.3-1l6-7c1.101-1.3.9-3.2-.3-4.2-1.3-1.1-3.2-.9-4.2.3l-6 7c-1.1 1.3-.899 3.2.3 4.2.5.5 1.2.7 1.9.7z"
        }
      }
    },
    custom83: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M74.6 39.3c.4.4 1 .4 1.4 0l1.4-1.4c3.4-3.4 3.5-8.6.2-11.9 0 0-4.3-4.4-4.399-4.4-3.4-2.8-8.101-1.5-10.8 1.2L61 24.2c-.4.4-.4 1 0 1.4l13.6 13.7zM56.6 29.8c-.399-.4-1-.4-1.399 0L27.7 57.1c-1.5 1.5-2.6 3.301-3.3 5.4L20.2 76c-.3.8-.2 1.8.2 2.5.6 1 1.6 1.5 2.6 1.5.3 0 .6 0 .9-.1 0 0 9.2-2.9 13.7-4.301 2-.6 3.8-1.699 5.3-3.199L70.3 45c.4-.4.4-1 0-1.4L56.6 29.8zM35.8 69.9c-2.1.699-5.4 1.699-8.2 2.6l2.6-8.2c.3-1.1.9-2 1.7-2.8l6.7 6.7c-.8.8-1.8 1.4-2.8 1.7z"
        }
      }
    },
    custom84: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M75 64H25c-1.7 0-3 1.3-3 3s1.3 3 3 3h4l1.7 8.5c.2.9 1 1.5 1.9 1.5h32.9c.9 0 1.7-.6 1.9-1.5L69 70h6c1.7 0 3-1.3 3-3s-1.3-3-3-3zM33 58h14v-5.6c-1.2-.7-2-2-2-3.4 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.5-.8 2.8-2 3.4V58h14c1.1 0 2-.9 2-2v-3c0-6.1-5.8-8.2-10.4-10.1-3.1-1.3-3.6-2.5-3.6-3.7 0-1.3.9-2.5 1.9-3.4 1.8-1.6 2.899-3.9 2.899-6.6 0-4.9-3.2-9.2-8.8-9.2-5.6 0-8.8 4.3-8.8 9.2 0 2.7 1 4.9 2.9 6.6 1 .9 1.9 2.1 1.9 3.4 0 1.3-.5 2.4-3.6 3.7C36.8 44.8 31 47.2 31 53v3c0 1.1.9 2 2 2z"
        }
      }
    },
    custom85: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M78 24H28v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v56c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V32h50c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2z"
        }, {
          "d": "M74 38H40c-3.3 0-6 2.7-6 6v22c0 3.3 2.7 6 6 6h34c3.3 0 6-2.7 6-6V44c0-3.3-2.7-6-6-6zm-5.5 17H66v10c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-6c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v6c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1V55h-2.5c-.5 0-.7-.6-.3-.9l11.2-10.9c.399-.3.899-.3 1.3 0l11.2 10.9c.3.3.1.9-.4.9z"
        }]
      }
    },
    custom86: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M38 30h4c.6 0 1-.4 1-1v-3h14v3c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-3c0-3.3-2.7-6-6-6H43c-3.3 0-6 2.7-6 6v3c0 .6.4 1 1 1zM74 36H26c-3.3 0-6 2.7-6 6v32c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V42c0-3.3-2.7-6-6-6zM50 72c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14z"
        }, {
          "d": "M56 55h-3v-3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3h-3c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h3v3c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-3h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2z"
        }]
      }
    },
    custom87: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M75 20H25c-1.7 0-3 1.3-3 3v48c0 1.7 1.3 3 3 3h1v3c0 1.7 1.3 3 3 3h2c1.7 0 3-1.3 3-3v-3h32v3c0 1.7 1.3 3 3 3h2c1.7 0 3-1.3 3-3v-3h1c1.7 0 3-1.3 3-3V23c0-1.7-1.3-3-3-3zM31 68c-1.7 0-3-1.3-3-3V29c0-1.7 1.3-3 3-3h38c1.7 0 3 1.3 3 3v36c0 1.7-1.3 3-3 3H31z"
        }, {
          "d": "M64 32H36c-1.1 0-2 .9-2 2v26c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V34c0-1.1-.9-2-2-2zm-4.7 18H51c-1.1 2-3.4 4-6.2 4-3.8 0-6.8-3.2-6.8-7s3-7 6.8-7c2.8 0 5.2 2 6.2 4h8.2c1.5 0 2.7 1.5 2.7 3s-1.1 3-2.6 3z"
        }]
      }
    },
    custom88: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M78.1 70H21.9c-1 0-1.9.8-1.9 1.8v.1c0 4.5 5.6 8.1 10 8.1h40c4.4 0 10-3.6 10-8.1v-.1c0-1-.9-1.8-1.9-1.8zM23 64h18c1.1 0 2-1.1 2-2.2V27.4c0-.5-.7-.7-.9-.2l-20 35.2c-.3.7.1 1.6.9 1.6zM51 64h25c1.2 0 2.1-1.1 2-2.3-.9-7.2-2.1-29.6-27.6-41.6-.6-.3-1.4.1-1.4.9v40.8c0 1.1.9 2.2 2 2.2z"
        }
      }
    },
    custom89: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M57.9 43.4c-.4-.5-1.2-.4-1.5.2-1.2 1.7-2.4 4.3-2.4 7.4v11c0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3v-3.1-31.101c0-7.7-6.7-8.9-11.6-7C35.1 21.2 33.9 22 33 23c-.6.7-1.3 1.3-2.2 1.6-1.8.6-4.9-1.1-6.5-2.1-.9-.5-2.1-.3-2.7.5l-1.2 1.7c-.7.9-.4 2.3.5 2.9 1.9 1.2 4.9 3.1 7.2 3.5 3.5.6 6.7-.5 9.3-2.9l-.1.1c.7-.6 1.9-1.6 2.7-.5 2 3-6 16.1-6 35.2v1.6c0 8.1 8.2 15.1 16.3 15.5 8.6.4 15.7-6.5 15.7-15 0-4.3 1.6-7.1 3.2-8.8a.967.967 0 000-1.399L57.9 43.4zM77 53c-.8 0-1.5-.3-2.1-.9l-16-16c-1.2-1.2-1.2-3.1 0-4.2 1.199-1.2 3.1-1.2 4.199 0l16 16c1.2 1.2 1.2 3.1 0 4.2-.599.6-1.299.9-2.099.9z"
        }
      }
    },
    custom9: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M62 20H45.1c-2.5 0-4.7 1.5-5.6 3.8L29 50.9c-.8 2 .7 4.1 2.8 4.1H49l-6.4 22.4c-.6 2.1 2 3.5 3.4 1.8L72.3 48c1.7-1.9.3-5-2.3-5H57l11.4-18.4c1.199-2-.2-4.6-2.601-4.6H62z"
      }
    },
    custom90: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M77.4 26L53 29.6V64c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1V30.5L23.4 34H23c-1.5 0-2.8-1.1-3-2.6-.2-1.6.9-3.2 2.5-3.4l18.6-2.8c1.7-3.1 5-5.3 8.8-5.3 2.8 0 5.2 1.1 7 2.9L76.6 20c1.601-.2 3.2.9 3.4 2.5.2 1.7-.9 3.2-2.6 3.5z"
        }, {
          "d": "M41.3 62.9c.7-.9.9-2 .4-3.101l-8-19C33.3 39.7 32.2 39 31 39s-2.3.7-2.8 1.8l-8 19c-.4.9-.3 1.9.2 2.8.2.3 4.1 6.3 10.4 6.3 3.7 0 7.3-2 10.5-6zM31 49.7L35.3 60h-8.6L31 49.7zM71.8 34.8a3.077 3.077 0 00-5.6 0l-8 19c-.4.9-.3 1.9.2 2.8.2.3 4.1 6.3 10.4 6.3 3.7 0 7.2-2 10.5-6 .7-.9.9-2 .4-3.101L71.8 34.8zM69 43.7L73.3 54h-8.6L69 43.7zM50 71c-5.6 0-11.3 2-15.3 5.4-.4.4-.7.9-.7 1.5v.1c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2v-.1c0-.601-.2-1.101-.7-1.5C61.3 73 55.6 71 50 71z"
        }]
      }
    },
    custom91: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M77.8 32.6c-3-.9-5.6-3-7.3-5.7-1.3-2.1-1.4-6.9-4.6-6.9H34.1c-3.3 0-3.3 4.8-4.6 6.9-2.1 3.3-4.8 4.1-8 6-3.3 1.9-.2 9.9.5 12.7 3.1 11.1 9 21.4 18.2 28.7 2.6 2.101 5.4 3.9 8.4 5.4 2.7 1.399 7.2-2.5 9.2-4C63 72 67.3 67.3 70.7 62c2.899-4.6 5.1-9.6 6.7-14.8.6-2.1 1.2-4.2 1.6-6.4.4-1.8 1.3-4.6.7-6.4-.2-.8-1-1.5-1.9-1.8-4.6-1.4 1.4.4 0 0zm-4.4 7C70.7 53 63.5 65.5 51.6 72.8l-1.6 1-1.6-1C34 64 28.6 49.9 26.6 39.6l-.4-2.1 1.8-1.1c3.1-1.9 6-5.2 7.7-8.7l.8-1.8h27l.5 1.3c1.7 3.8 4.8 7.4 8.5 9.5l1.3.7v.1l-.4 2.1z"
        }, {
          "d": "M48.9 32c-2.3 0-7.9 0-9 1-1.9 1.7-3 4.2-5 5.9-2.1 1.8-1.1 3.6-.4 6 1.4 4.2 3.3 8.3 5.9 12 1.3 1.899 2.8 3.699 4.5 5.3.5.5 5.1 5.1 5.1 2.2V34c0-1.1 0-2-1.1-2z"
        }]
      }
    },
    custom92: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M73.7 56.4L50.9 46c-.601-.3-1.2-.3-1.8 0L26.3 56.4c-1.3.6-1.7 2.1-.9 3.3 2.4 3.399 3.9 7.8 4.5 9.8.2.8.9 1.3 1.6 1.5 7.9 1.9 14.4 6.4 17.1 8.5.8.6 1.9.6 2.7 0 2.7-2.1 9.3-6.6 17.1-8.5.8-.2 1.399-.7 1.6-1.5.6-2.1 2.1-6.5 4.5-9.8.9-1.1.5-2.7-.8-3.3zM44 62c-1.7 0-3-1.8-3-4s1.3-4 3-4 3 1.8 3 4-1.3 4-3 4zm12 0c-1.7 0-3-1.8-3-4s1.3-4 3-4 3 1.8 3 4-1.3 4-3 4z"
        }, {
          "d": "M34.4 46.1l12.2-5.6c1.5-.7 3.1-.9 4.8-.6.699.1 1.399.4 2.1.7l12.1 5.6c.7.3 1.4-.2 1.4-.9v-4.5c0-.5-.2-1-.6-1.4-.8-.9-2.4-2.4-5.4-2.4v-5.9c0-.7-.4-1.4-1-1.7-1.1-.6-3-1.5-6-2V22c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v5.4c-3 .5-4.9 1.4-6 2-.6.3-1 1-1 1.7V37c-3 0-4.6 1.5-5.4 2.3-.4.4-.6.9-.6 1.4v4.5c0 .7.7 1.2 1.4.9z"
        }]
      }
    },
    custom93: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M42.4 50h29.5c.899 0 1.699-.6 1.899-1.5l5.4-19C79.6 28.2 78.6 27 77.3 27H31.7l-.8-2.8c-.4-1.3-1.6-2.2-2.9-2.2h-4.8c-1.6 0-3.1 1.2-3.2 2.8-.1 1.7 1.3 3.2 3 3.2h2.8l9.4 31.8c.4 1.3 1.5 2.2 2.9 2.2h34.8c1.6 0 3.1-1.2 3.199-2.8.101-1.7-1.3-3.2-3-3.2H42.5c-1.3 0-2.5-.9-2.8-2.1v-.1c-.7-1.9.8-3.8 2.7-3.8z"
        },
        "circle": [{
          "cx": "43",
          "cy": "73",
          "r": "5"
        }, {
          "cx": "67",
          "cy": "73",
          "r": "5"
        }]
      }
    },
    custom94: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M56 38V23c0-1.7-1.3-3-3-3h-4c-1.7 0-3 1.3-3 3s1.3 3 3 3h1v12c0 6.6-5.4 12-12 12s-12-5.4-12-12V26h1c1.7 0 3-1.3 3-3s-1.3-3-3-3h-4c-1.7 0-3 1.3-3 3v15c0 9.9 8.1 18 18 18s18-8.1 18-18z"
        }, {
          "d": "M80 50c0-5-4-9-9-9s-9 4-9 9c0 3.9 2.5 7.2 6 8.5v2.2C68 68 62 74 54.7 74h-.3c-6.3 0-11.601-4.5-13-10.4-.2-.899-1-1.6-2-1.6h-2c-1.3 0-2.2 1.2-2 2.4C37.1 73.3 45 80 54.3 80h.3C65.3 80 74 71.3 74 60.7v-2.2c3.5-1.3 6-4.6 6-8.5zm-9 3c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        }]
      }
    },
    custom95: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M53 30.2V26h1c1.6 0 3-1.3 3-3 0-1.6-1.3-3-3-3h-8c-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3h1v4.2c-12.4 1.5-22 12-22 24.8 0 13.8 11.2 25 25 25s25-11.2 25-25c0-12.8-9.6-23.3-22-24.8zM50 74c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19-8.5 19-19 19z"
        }, {
          "d": "M56.6 44.8L52 49.4c-.6-.2-1.3-.4-2-.4-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6c0-.7-.1-1.4-.4-2l4.601-4.6c1-1 1-2.6 0-3.6-1.001-1.1-2.601-1.1-3.601 0z"
        }]
      }
    },
    custom96: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M79.4 28.7l-5.2-3.9c-.7-.5-1.5-.8-2.4-.8H54v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H26c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h45.7c.899 0 1.7-.3 2.399-.8l5.2-3.9c.901-.7.901-1.9.101-2.6zM74 46H54v-3c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v3H28.3c-.9 0-1.7.3-2.4.8l-5.2 3.9c-.9.6-.9 1.899 0 2.6l5.2 3.9c.7.5 1.5.8 2.4.8H74c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zM54 71.6V65c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v6.6c-4 1.101-6.2 3.5-6.9 6.5-.2.9.5 1.9 1.5 1.9h18.9c1 0 1.7-.9 1.5-1.9-.8-3-3-5.4-7-6.5z"
        }
      }
    },
    custom97: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M60 54.4V29.1C60 22.9 55.2 18 49.1 18h-.2C42.8 18 38 22.9 38 29.1v25.3c-3.2 3-5 7.199-5 11.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-4.5-1.8-8.6-5-11.6zM57.4 66H40.6c-.9 0-1.6-.9-1.5-1.8.4-2.4 1.7-4.5 3.6-6 .7-.601 1.2-1.5 1.2-2.4V29.1c0-2.9 2.2-5.1 4.9-5.1h.2c2.8 0 4.9 2.2 4.9 5.1v.9h-3c-1.7 0-3 1.3-3 3s1.3 3 3 3h3v4h-3c-1.7 0-3 1.3-3 3s1.3 3 3 3h3v4h-3c-1.7 0-3 1.3-3 3s1.3 3 3 3h3c.1.9.5 1.6 1.199 2.2 1.9 1.5 3.2 3.7 3.601 6 .3.9-.4 1.8-1.3 1.8z"
      }
    },
    custom98: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M81.4 46.4l-7.8-7.8c-.4-.4-.9-.6-1.4-.6H64c-1.1 0-2 .9-2 2v16c0 .7.7 1.2 1.4.9 1.4-.6 3-.9 4.6-.9 4.5 0 8.4 2.5 10.5 6.2.3.5 1 .7 1.5.3 1.2-1.1 2-2.7 2-4.5V47.8c0-.5-.2-1-.6-1.4z"
        }, {
          "d": "M54 29H20c-1.1 0-2 .9-2 2v27c0 1.8.8 3.4 2 4.5.5.4 1.2.3 1.5-.3 2-3.7 6-6.2 10.5-6.2 5 0 9.2 3 11.1 7.4.2.4.5.6.9.6h6c3.3 0 6-2.7 6-6V31c0-1.1-.9-2-2-2z"
        }],
        "circle": [{
          "cx": "68",
          "cy": "68",
          "r": "6"
        }, {
          "cx": "32",
          "cy": "68",
          "r": "6"
        }]
      }
    },
    custom99: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M74 36H57.2c-.5-1.2-1.2-2.2-2.101-3.1l6.301-8.1c1-1.3.8-3.2-.5-4.2-1.301-1-3.2-.8-4.2.5l-7 9c-.6 0-1.1-.1-1.7-.1s-1.1.1-1.6.1l-7-9c-1-1.3-2.9-1.5-4.2-.5-1.3 1-1.5 2.9-.5 4.2l6.3 8.1c-.9.9-1.6 1.9-2.1 3.1H26c-3.3 0-6 2.7-6 6v28c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6V42c0-3.3-2.7-6-6-6zm-8 32c0 1.1-.9 2-2 2H28c-1.1 0-2-.9-2-2V44c0-1.1.9-2 2-2h36c1.1 0 2 .9 2 2v24zm7-10c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-10c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
      }
    },
    viewBox: '0 0 100 100'
  };
}

export default icons;